var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _g, _g2, _g3, _path43, _path44, _path45, _path46, _path47, _g4, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _g5, _path79, _path80, _path81, _path82, _g6, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _g7, _path100, _g8, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _g9, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _g10, _g11, _g12, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _g13, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _g14, _path192, _g15, _path193, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCmsHeader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 480,
    height: 349,
    viewBox: "0 0 480 349",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M431.905 321.034H400.109V321.274H431.905V321.034Z",
    fill: "#AABDD4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M317.971 323.646H309.629V323.886H317.971V323.646Z",
    fill: "#AABDD4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M399.149 312.126H380.727V312.366H399.149V312.126Z",
    fill: "#AABDD4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M91.8257 313.738H50.3633V313.978H91.8257V313.738Z",
    fill: "#AABDD4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M106.454 313.738H100.377V313.978H106.454V313.738Z",
    fill: "#AABDD4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M216.144 317.79H126.211V318.03H216.144V317.79Z",
    fill: "#AABDD4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M480 305.588H0V305.828H480V305.588Z",
    fill: "#AABDD4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M287.548 291.351H290.428C293.903 291.351 296.274 289.086 295.727 286.282L270.546 158.238C269.989 155.434 266.706 153.169 263.26 153.169H63.1094L90.239 291.351H287.548Z",
    fill: "#DCEAF8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7002 291.351C87.4378 291.351 83.4346 288.567 82.753 285.13L58.0522 159.37C57.3706 155.934 60.2794 153.15 64.5514 153.15C68.8138 153.15 72.817 155.934 73.489 159.37L98.1994 285.13C98.881 288.567 96.001 291.351 91.7002 291.351Z",
    fill: "#B3CCE5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M204.902 291.351H422.054V302.151C422.054 303.082 421.687 303.974 421.033 304.636C420.379 305.297 419.49 305.674 418.56 305.684H204.902V291.351Z",
    fill: "#AABDD4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1992 291.351H242.879V302.151C242.879 303.088 242.507 303.987 241.844 304.649C241.182 305.312 240.283 305.684 239.346 305.684H94.6936C93.7633 305.674 92.8746 305.297 92.2203 304.636C91.5661 303.974 91.1992 303.082 91.1992 302.151V291.351Z",
    fill: "#B3CCE5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M338.881 291.351C338.958 293.828 341.463 295.825 344.554 295.825H368.036C371.127 295.825 373.633 293.828 373.71 291.351H338.881Z",
    fill: "#B3CCE5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M280.302 280.484H109.815L86.7754 163.239H257.262L280.302 280.484Z",
    fill: "#B3CCE5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M173.856 157.268C173.969 157.788 173.919 158.331 173.711 158.821C173.503 159.311 173.148 159.724 172.695 160.004C172.242 160.284 171.714 160.416 171.182 160.383C170.651 160.35 170.143 160.153 169.729 159.819C169.314 159.485 169.013 159.031 168.868 158.519C168.722 158.007 168.739 157.462 168.916 156.96C169.093 156.458 169.421 156.023 169.855 155.716C170.29 155.408 170.809 155.243 171.341 155.242C171.942 155.186 172.541 155.365 173.011 155.744C173.48 156.122 173.784 156.669 173.856 157.268Z",
    fill: "#B3CCE5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M403.199 223.834C403.315 222.628 403.25 221.412 403.007 220.225L406.386 217.767L404.735 214.177L400.665 215.137C399.17 213.212 397.139 211.773 394.828 210.999L394.386 206.842L390.45 206.487L389.25 210.49C386.836 210.824 384.574 211.867 382.751 213.486L378.911 211.786L376.626 215.012L379.506 218.046C378.58 220.304 378.349 222.788 378.844 225.178L375.465 227.636L377.116 231.226L381.186 230.266C382.683 232.194 384.718 233.633 387.033 234.404L387.465 238.561L391.401 238.926L392.601 234.913C395.016 234.581 397.279 233.539 399.1 231.918L402.94 233.617L405.215 230.391L402.335 227.358C402.801 226.234 403.093 225.046 403.199 223.834ZM390.287 229.364C389.025 229.248 387.825 228.76 386.841 227.961C385.856 227.163 385.131 226.09 384.756 224.879C384.382 223.668 384.375 222.373 384.738 221.158C385.1 219.943 385.815 218.863 386.791 218.055C387.768 217.247 388.963 216.746 390.224 216.618C391.485 216.489 392.756 216.738 393.876 217.332C394.995 217.926 395.914 218.839 396.514 219.956C397.114 221.073 397.369 222.342 397.247 223.604C397.087 225.29 396.264 226.844 394.959 227.924C393.654 229.004 391.974 229.522 390.287 229.364Z",
    fill: "#DCEAF8"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M418.56 240.481C418.563 239.573 418.43 238.671 418.167 237.802L420.509 235.748L418.992 233.204L416.036 234.164C414.791 232.835 413.181 231.903 411.408 231.486L410.794 228.423H407.837L407.232 231.486C405.459 231.901 403.849 232.833 402.605 234.164L399.639 233.204L398.17 235.767L400.512 237.822C399.987 239.565 399.987 241.425 400.512 243.169L398.17 245.233L399.639 247.786L402.605 246.826C403.847 248.158 405.458 249.087 407.232 249.495L407.837 252.558H410.794L411.408 249.495C413.182 249.085 414.793 248.156 416.036 246.826L418.992 247.786L420.461 245.233L418.119 243.169C418.401 242.3 418.549 241.394 418.56 240.481ZM409.364 245.444C408.414 245.444 407.486 245.162 406.697 244.635C405.907 244.108 405.292 243.358 404.929 242.481C404.566 241.604 404.471 240.639 404.656 239.708C404.841 238.776 405.298 237.921 405.969 237.25C406.641 236.579 407.496 236.121 408.427 235.936C409.358 235.751 410.323 235.846 411.2 236.209C412.077 236.573 412.827 237.188 413.355 237.977C413.882 238.767 414.164 239.695 414.164 240.644C414.164 241.278 414.038 241.907 413.794 242.492C413.549 243.078 413.192 243.609 412.741 244.055C412.29 244.502 411.755 244.854 411.167 245.092C410.579 245.331 409.95 245.45 409.316 245.444H409.364Z",
    fill: "#DCEAF8"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M396.671 95.2232H364.031V62.5832H396.671V95.2232ZM364.991 94.2632H395.711V63.5432H364.991V94.2632Z",
    fill: "#B3CCE5"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M403.43 119.646H358.512V107.962H403.43V119.646ZM359.472 118.686H402.47V108.922H359.472V118.686Z",
    fill: "#B3CCE5"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M358.704 155.262H340.656V137.204H358.704V155.262ZM341.616 154.302H357.744V138.164H341.616V154.302Z",
    fill: "#B3CCE5"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M379.612 155.262H361.564V137.204H379.612V155.262ZM362.524 154.302H378.652V138.164H362.524V154.302Z",
    fill: "#B3CCE5"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M400.521 155.262H382.473V137.204H400.521V155.262ZM383.433 154.302H399.561V138.164H383.433V154.302Z",
    fill: "#B3CCE5"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M421.439 155.262H403.391V137.204H421.439V155.262ZM404.351 154.302H420.479V138.164H404.351V154.302Z",
    fill: "#B3CCE5"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M412.896 137.454H411.936V130.906H349.728V137.454H348.768V129.946H412.896V137.454Z",
    fill: "#B3CCE5"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M381.522 119.166H380.562V130.426H381.522V119.166Z",
    fill: "#B3CCE5"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M381.522 94.4167H380.562V108.442H381.522V94.4167Z",
    fill: "#B3CCE5"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M371.444 130.426H370.484V137.694H371.444V130.426Z",
    fill: "#B3CCE5"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M391.804 130.426H390.844V137.694H391.804V130.426Z",
    fill: "#B3CCE5"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M105.052 81.1976H71.9414V69.524H105.052V81.1976ZM72.9014 80.2376H104.092V70.484H72.9014V80.2376Z",
    fill: "#B3CCE5"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M110.956 58.7144H66.0371V47.0312H110.956V58.7144ZM66.9971 57.7544H109.996V47.9912H66.9971V57.7544Z",
    fill: "#B3CCE5"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6086 111.466H58.5605V93.4184H76.6086V111.466ZM59.5205 110.506H75.6486V94.3784H59.5205V110.506Z",
    fill: "#B3CCE5"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5265 111.466H79.4785V93.4184H97.5265V111.466ZM80.4385 110.506H96.5665V94.3784H80.4385V110.506Z",
    fill: "#B3CCE5"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M118.435 111.466H100.387V93.4184H118.435V111.466ZM101.347 110.506H117.475V94.3784H101.347V110.506Z",
    fill: "#B3CCE5"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M109.152 94.9064L88.4925 81.572L67.8334 93.956L67.3438 93.1304L88.5022 80.4488L109.67 94.1L109.152 94.9064Z",
    fill: "#B3CCE5"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9834 81.0056H88.0234V93.5432H88.9834V81.0056Z",
    fill: "#B3CCE5"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9834 59.1848H88.0234V71.0696H88.9834V59.1848Z",
    fill: "#B3CCE5"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M240 348.414C342.799 348.414 426.134 343.548 426.134 337.546C426.134 331.545 342.799 326.679 240 326.679C137.2 326.679 53.8652 331.545 53.8652 337.546C53.8652 343.548 137.2 348.414 240 348.414Z",
    fill: "#DCEAF8"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M376.081 0.58638H95.8184V213.284H376.081V0.58638Z",
    fill: "url(#paint0_linear_559_64061)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M376.081 0.58638H95.8184V213.284H376.081V0.58638Z",
    fill: "#F0F7FF"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M376.08 0.58638H95.9902V14.6408H376.08V0.58638Z",
    fill: "url(#paint1_linear_559_64061)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M107.895 7.69038C107.895 8.23911 107.732 8.77551 107.427 9.23176C107.122 9.68801 106.689 10.0436 106.182 10.2536C105.675 10.4636 105.117 10.5185 104.579 10.4115C104.041 10.3044 103.546 10.0402 103.158 9.65218C102.77 9.26418 102.506 8.76983 102.399 8.23164C102.292 7.69346 102.347 7.13563 102.557 6.62867C102.767 6.12172 103.122 5.68841 103.579 5.38356C104.035 5.0787 104.571 4.91599 105.12 4.91599C105.856 4.91599 106.562 5.20829 107.082 5.72859C107.602 6.24889 107.895 6.95457 107.895 7.69038Z",
    fill: "#F0F7FF"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M117.582 7.69038C117.582 8.23911 117.419 8.77551 117.114 9.23176C116.81 9.68801 116.376 10.0436 115.869 10.2536C115.362 10.4636 114.805 10.5185 114.266 10.4115C113.728 10.3044 113.234 10.0402 112.846 9.65218C112.458 9.26418 112.194 8.76983 112.087 8.23164C111.979 7.69346 112.034 7.13563 112.244 6.62867C112.454 6.12172 112.81 5.68841 113.266 5.38356C113.722 5.0787 114.259 4.91599 114.808 4.91599C115.543 4.91599 116.249 5.20829 116.769 5.72859C117.29 6.24889 117.582 6.95457 117.582 7.69038Z",
    fill: "#F0F7FF"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M127.26 7.69037C127.26 8.23909 127.097 8.7755 126.792 9.23174C126.487 9.68799 126.054 10.0436 125.547 10.2536C125.04 10.4636 124.482 10.5185 123.944 10.4115C123.406 10.3044 122.912 10.0402 122.524 9.65217C122.136 9.26416 121.871 8.76981 121.764 8.23163C121.657 7.69345 121.712 7.13561 121.922 6.62866C122.132 6.1217 122.488 5.6884 122.944 5.38354C123.4 5.07869 123.937 4.91597 124.485 4.91597C125.221 4.91597 125.927 5.20828 126.447 5.72858C126.967 6.24888 127.26 6.95455 127.26 7.69037Z",
    fill: "#F0F7FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M251.088 38.7847H250.128V37.3447H248.688V36.3847H251.088V38.7847Z",
    fill: "#F0F7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.079 55.2007H250.119V51.1015H251.079V55.2007ZM251.079 46.9927H250.119V42.8935H251.079V46.9927Z",
    fill: "#F0F7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.079 104.449H250.119V100.34H251.079V104.449ZM251.079 96.2407H250.119V92.1319H251.079V96.2407ZM251.079 88.0327H250.119V83.9335H251.079V88.0327ZM251.079 79.8247H250.119V75.7639H251.079V79.8247ZM251.079 71.6167H250.119V67.5175H251.079V71.6167ZM251.079 63.4087H250.119V59.3095H251.079V63.4087Z",
    fill: "#F0F7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.088 110.948H248.688V109.988H250.128V108.548H251.088V110.948Z",
    fill: "#F0F7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.982 110.948H241.277V109.988H244.982V110.948ZM237.581 110.948H233.875V109.988H237.581V110.948Z",
    fill: "#F0F7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.18 110.948H226.474V109.988H230.18V110.948ZM222.778 110.948H219.072V109.988H222.778V110.948ZM215.367 110.948H211.671V109.988H215.367V110.948ZM207.965 110.948H204.269V109.988H207.965V110.948ZM200.564 110.948H196.868V109.988H200.564V110.948ZM193.162 110.948H189.466V109.988H193.162V110.948ZM185.76 110.948H182.055V109.988H185.76V110.948ZM178.359 110.948H174.653V109.988H178.359V110.948ZM170.957 110.948H167.252V109.988H170.957V110.948ZM163.556 110.948H159.85V109.988H163.556V110.948ZM156.154 110.948H152.448V109.988H156.154V110.948ZM148.743 110.948H145.047V109.988H148.743V110.948Z",
    fill: "#F0F7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.341 110.948H138.941V108.548H139.901V109.988H141.341V110.948Z",
    fill: "#F0F7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.901 104.449H138.941V100.34H139.901V104.449ZM139.901 96.2408H138.941V92.132H139.901V96.2408Z",
    fill: "#F0F7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.901 88.0327H138.941V83.9239H139.901V88.0327ZM139.901 79.8247H138.941V75.7639H139.901V79.8247ZM139.901 71.6167H138.941V67.5175H139.901V71.6167ZM139.901 63.4087H138.941V59.3095H139.901V63.4087ZM139.901 55.2007H138.941V51.1015H139.901V55.2007ZM139.901 46.9927H138.941V42.8935H139.901V46.9927Z",
    fill: "#F0F7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.901 38.7847H138.941V36.3847H141.341V37.3447H139.901V38.7847Z",
    fill: "#F0F7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.154 37.3639H152.448V36.4039H156.154V37.3639ZM148.743 37.3639H145.047V36.4039H148.743V37.3639Z",
    fill: "#F0F7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.984 37.3639H241.279V36.4039H244.984V37.3639ZM237.583 37.3639H233.877V36.4039H237.583V37.3639ZM230.181 37.3639H226.476V36.4039H230.181V37.3639ZM222.78 37.3639H219.074V36.4039H222.78V37.3639ZM215.368 37.3639H211.672V36.4039H215.368V37.3639ZM207.967 37.3639H204.271V36.4039H207.967V37.3639ZM200.565 37.3639H196.869V36.4039H200.565V37.3639ZM193.164 37.3639H189.468V36.4039H193.164V37.3639ZM185.762 37.3639H182.056V36.4039H185.762V37.3639ZM178.36 37.3639H174.655V36.4039H178.36V37.3639ZM170.959 37.3639H167.253V36.4039H170.959V37.3639ZM163.557 37.3639H159.852V36.4039H163.557V37.3639Z",
    fill: "#F0F7FF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M333.947 121.969H332.987V120.529H331.547V119.569H333.947V121.969Z",
    fill: "#F0F7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.948 137.53H332.988V133.642H333.948V137.53ZM333.948 129.754H332.988V125.866H333.948V129.754Z",
    fill: "#F0F7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.948 184.244H332.988V180.346H333.948V184.244ZM333.948 176.458H332.988V172.57H333.948V176.458ZM333.948 168.682H332.988V164.785H333.948V168.682ZM333.948 160.897H332.988V157.057H333.948V160.897ZM333.948 153.111H332.988V149.204H333.948V153.111ZM333.948 145.335H332.988V141.495H333.948V145.335Z",
    fill: "#F0F7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.947 190.513H331.547V189.553H332.987V188.113H333.947V190.513Z",
    fill: "#F0F7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.439 190.513H323.321V189.553H327.439V190.513ZM319.212 190.513H315.094V189.553H319.212V190.513Z",
    fill: "#F0F7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.983 190.513H306.865V189.553H310.983V190.513ZM302.756 190.513H298.637V189.553H302.756V190.513ZM294.529 190.513H290.41V189.553H294.529V190.513ZM286.301 190.513H282.241V189.553H286.349L286.301 190.513ZM278.074 190.513H273.965V189.553H278.074V190.513ZM269.847 190.513H265.738V189.553H269.847V190.513ZM261.62 190.513H257.511V189.553H261.62V190.513ZM253.393 190.513H249.284V189.553H253.441L253.393 190.513ZM245.165 190.513H241.057V189.553H245.165V190.513Z",
    fill: "#F0F7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.939 190.513H234.539V188.113H235.499V189.553H236.939V190.513Z",
    fill: "#F0F7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.499 184.244H234.539V180.346H235.499V184.244ZM235.499 176.458H234.539V172.57H235.499V176.458Z",
    fill: "#F0F7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.499 168.654H234.539V164.814H235.499V168.654ZM235.499 160.878H234.539V157.038H235.499V160.878ZM235.499 153.092H234.539V149.204H235.499V153.092ZM235.499 145.316H234.539V141.476H235.499V145.316ZM235.499 137.53H234.539V133.642H235.499V137.53ZM235.499 129.754H234.539V125.857H235.499V129.754Z",
    fill: "#F0F7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.499 121.969H234.539V119.569H236.939V120.529H235.499V121.969Z",
    fill: "#F0F7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.441 120.529H249.332V119.569H253.441V120.529ZM245.213 120.529H241.057V119.569H245.165L245.213 120.529Z",
    fill: "#F0F7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.438 120.529H323.32V119.569H327.438V120.529ZM319.211 120.529H315.093V119.569H319.211V120.529ZM310.984 120.529H306.865V119.569H310.984V120.529ZM302.757 120.529H298.638V119.569H302.757V120.529ZM294.529 120.529H290.421V119.569H294.529V120.529ZM286.302 120.529H282.241V119.569H286.35L286.302 120.529ZM278.075 120.529H273.966V119.569H278.075V120.529ZM269.848 120.529H265.739V119.569H269.848V120.529ZM261.621 120.529H257.512V119.569H261.621V120.529Z",
    fill: "#F0F7FF"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M228.412 121.854H227.452V120.414H226.012V119.454H228.412V121.854Z",
    fill: "#F0F7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.413 137.473H227.453V133.566H228.413V137.473ZM228.413 129.658H227.453V125.751H228.413V129.658Z",
    fill: "#F0F7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.413 184.33H227.453V180.404H228.413V184.33ZM228.413 176.516H227.453V172.609H228.413V176.516ZM228.413 168.711H227.453V164.804H228.413V168.711ZM228.413 160.897H227.453V156.99H228.413V160.897ZM228.413 153.092H227.453V149.185H228.413V153.092ZM228.413 145.278H227.453V141.37H228.413V145.278Z",
    fill: "#F0F7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.412 190.628H226.012V189.668H227.452V188.228H228.412V190.628Z",
    fill: "#F0F7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.337 190.628H218.66V189.668H222.337V190.628ZM214.983 190.628H211.307V189.668H214.983V190.628Z",
    fill: "#F0F7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.628 190.628H203.952V189.668H207.628V190.628ZM200.275 190.628H196.588V189.668H200.275V190.628ZM192.912 190.628H189.235V189.668H192.96L192.912 190.628ZM185.558 190.628H181.881V189.668H185.558V190.628ZM178.204 190.628H174.528V189.668H178.204V190.628ZM170.851 190.628H167.174V189.668H170.88L170.851 190.628ZM163.497 190.628H159.811V189.668H163.497V190.628ZM156.134 190.628H152.457V189.668H156.134V190.628ZM148.78 190.628H145.104V189.668H148.8L148.78 190.628Z",
    fill: "#F0F7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.427 190.628H139.027V188.228H139.987V189.668H141.427V190.628Z",
    fill: "#F0F7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.987 184.33H139.027V180.404H139.987V184.33ZM139.987 176.516H139.027V172.609H139.987V176.516Z",
    fill: "#F0F7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.987 168.711H139.027V164.804H139.987V168.711ZM139.987 160.897H139.027V156.99H139.987V160.897ZM139.987 153.092H139.027V149.185H139.987V153.092ZM139.987 145.278H139.027V141.37H139.987V145.278ZM139.987 137.473H139.027V133.566H139.987V137.473ZM139.987 129.658H139.027V125.751H139.987V129.658Z",
    fill: "#F0F7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.987 121.854H139.027V119.454H141.427V120.414H139.987V121.854Z",
    fill: "#F0F7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.134 120.414H152.457V119.454H156.134V120.414ZM148.78 120.414H145.104V119.454H148.8L148.78 120.414Z",
    fill: "#F0F7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.337 120.414H218.661V119.454H222.337V120.414ZM214.984 120.414H211.307V119.454H214.984V120.414ZM207.63 120.414H203.953V119.454H207.63V120.414ZM200.276 120.414H196.59V119.454H200.276V120.414ZM192.913 120.414H189.236V119.454H192.961L192.913 120.414ZM185.56 120.414H181.883V119.454H185.56V120.414ZM178.206 120.414H174.529V119.454H178.206V120.414ZM170.853 120.414H167.176V119.454H170.881L170.853 120.414ZM163.499 120.414H159.812V119.454H163.499V120.414Z",
    fill: "#F0F7FF"
  }))), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M300.721 120.02H299.761V118.964H300.721V120.02ZM300.721 115.143H299.761V111.303H300.721V115.143ZM300.721 107.463H299.761V103.623H300.721V107.463ZM300.721 99.7832H299.761V95.9432H300.721V99.7832ZM300.721 92.1032H299.761V88.2632H300.721V92.1032ZM300.721 84.4232H299.761V80.5832H300.721V84.4232ZM300.721 76.7432H299.761V72.9032H300.721V76.7432ZM300.721 69.0632H299.761V65.2232H300.721V69.0632ZM300.241 61.5752H296.689V60.6152H300.721V61.3832H300.241V61.5752ZM292.849 61.5752H289.009V60.6152H292.849V61.5752ZM285.169 61.5752H281.329V60.6152H285.169V61.5752ZM277.489 61.5752H273.649V60.6152H277.489V61.5752ZM269.809 61.5752H265.969V60.6152H269.809V61.5752ZM262.129 61.5752H258.289V60.6152H262.129V61.5752ZM254.449 61.5752H250.609V60.6152H254.449V61.5752Z",
    fill: "#F0F7FF"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M127.334 25.748V98.6888H238.099V25.748H127.334Z",
    fill: "black"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M122.438 20.0456V92.9864H233.202V20.0456H122.438Z",
    fill: "url(#paint2_linear_559_64061)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M122.438 20.0456V92.9864H233.202V20.0456H122.438Z",
    fill: "#F0F7FF"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M179.058 25.5464H132.709C130.843 25.5464 129.33 27.0593 129.33 28.9256V67.4984C129.33 69.3647 130.843 70.8776 132.709 70.8776H179.058C180.924 70.8776 182.437 69.3647 182.437 67.4984V28.9256C182.437 27.0593 180.924 25.5464 179.058 25.5464Z",
    fill: "url(#paint3_linear_559_64061)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M179.058 25.5464H132.709C130.843 25.5464 129.33 27.0593 129.33 28.9256V67.4984C129.33 69.3647 130.843 70.8776 132.709 70.8776H179.058C180.924 70.8776 182.437 69.3647 182.437 67.4984V28.9256C182.437 27.0593 180.924 25.5464 179.058 25.5464Z",
    fill: "#F0F7FF"
  }))), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M179.137 27.5816H132.625C131.925 27.5816 131.357 28.1489 131.357 28.8488V67.5848C131.357 68.2846 131.925 68.852 132.625 68.852H179.137C179.836 68.852 180.404 68.2846 180.404 67.5848V28.8488C180.404 28.1489 179.836 27.5816 179.137 27.5816Z",
    fill: "url(#paint4_linear_559_64061)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M179.137 27.5816H132.625C131.925 27.5816 131.357 28.1489 131.357 28.8488V67.5848C131.357 68.2846 131.925 68.852 132.625 68.852H179.137C179.836 68.852 180.404 68.2846 180.404 67.5848V28.8488C180.404 28.1489 179.836 27.5816 179.137 27.5816Z",
    fill: "url(#paint5_linear_559_64061)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M144.164 46.964L131.357 66.692V67.604C131.36 67.9384 131.495 68.2583 131.732 68.4939C131.969 68.7294 132.29 68.8616 132.625 68.8616H158.401L144.164 46.964Z",
    fill: "#F0F7FF"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M180.404 63.5336L167.194 40.5704L150.932 68.8424H179.136C179.471 68.8424 179.792 68.7102 180.029 68.4747C180.266 68.2391 180.401 67.9192 180.404 67.5848V63.5336Z",
    fill: "url(#paint6_linear_559_64061)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M180.404 63.5336L167.194 40.5704L150.932 68.8424H179.136C179.471 68.8424 179.792 68.7102 180.029 68.4747C180.266 68.2391 180.401 67.9192 180.404 67.5848V63.5336Z",
    fill: "#F0F7FF"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M159.187 37.268C159.187 37.9235 158.992 38.5642 158.628 39.1091C158.263 39.6539 157.745 40.0784 157.14 40.3288C156.534 40.5792 155.868 40.6442 155.225 40.5157C154.582 40.3871 153.992 40.0707 153.529 39.6065C153.066 39.1424 152.752 38.5514 152.625 37.9083C152.498 37.2652 152.565 36.5989 152.817 35.9939C153.07 35.3889 153.496 34.8723 154.041 34.5095C154.587 34.1468 155.229 33.9541 155.884 33.956C156.319 33.956 156.749 34.0418 157.15 34.2083C157.551 34.3749 157.916 34.619 158.223 34.9267C158.529 35.2343 158.772 35.5995 158.938 36.0013C159.103 36.4031 159.188 36.8335 159.187 37.268Z",
    fill: "#F0F7FF"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M199.534 26.2568H193.361V27.2168H199.534V26.2568Z",
    fill: "url(#paint7_linear_559_64061)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M215.951 26.2568H202.568V27.2168H215.951V26.2568Z",
    fill: "url(#paint8_linear_559_64061)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M224.794 26.2568H219.543V27.2168H224.794V26.2568Z",
    fill: "url(#paint9_linear_559_64061)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M207.608 34.8488H186.949V35.8088H207.608V34.8488Z",
    fill: "url(#paint10_linear_559_64061)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M223.362 34.8488H212.332V35.8088H223.362V34.8488Z",
    fill: "url(#paint11_linear_559_64061)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M197.645 43.4409H188.621V44.4009H197.645V43.4409Z",
    fill: "url(#paint12_linear_559_64061)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M217.986 43.4408H200.648V44.4008H217.986V43.4408Z",
    fill: "url(#paint13_linear_559_64061)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M224.802 43.4409H221.164V44.4009H224.802V43.4409Z",
    fill: "url(#paint14_linear_559_64061)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M207.608 52.0231H186.949V52.9831H207.608V52.0231Z",
    fill: "url(#paint15_linear_559_64061)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M223.352 52.0231H211.496V52.9831H223.352V52.0231Z",
    fill: "url(#paint16_linear_559_64061)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M199.534 60.6152H193.361V61.5752H199.534V60.6152Z",
    fill: "url(#paint17_linear_559_64061)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M215.951 60.6152H202.568V61.5752H215.951V60.6152Z",
    fill: "url(#paint18_linear_559_64061)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M224.794 60.6152H219.543V61.5752H224.794V60.6152Z",
    fill: "url(#paint19_linear_559_64061)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M207.608 69.2072H186.949V70.1672H207.608V69.2072Z",
    fill: "url(#paint20_linear_559_64061)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M222.978 69.2072H212.332V70.1672H222.978V69.2072Z",
    fill: "url(#paint21_linear_559_64061)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M161.971 76.9928H130.857V77.9528H161.971V76.9928Z",
    fill: "url(#paint22_linear_559_64061)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M202.577 76.9928H169.477V77.9528H202.577V76.9928Z",
    fill: "url(#paint23_linear_559_64061)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M224.428 76.9928H211.439V77.9528H224.428V76.9928Z",
    fill: "url(#paint24_linear_559_64061)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M139.526 85.5753H130.857V86.5353H139.526V85.5753Z",
    fill: "url(#paint25_linear_559_64061)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M169.074 85.5753H145.842V86.5353H169.074V85.5753Z",
    fill: "url(#paint26_linear_559_64061)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M186.951 85.5753H174.125V86.5353H186.951V85.5753Z",
    fill: "url(#paint27_linear_559_64061)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M207.618 85.5753H193.602V86.5353H207.618V85.5753Z",
    fill: "url(#paint28_linear_559_64061)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M224.428 85.5753H213.484V86.5353H224.428V85.5753Z",
    fill: "url(#paint29_linear_559_64061)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M326.553 37.9976L326.659 96.212C326.659 96.5719 326.517 96.9172 326.263 97.1726C326.009 97.4279 325.665 97.5727 325.305 97.5752L271.478 97.6712C271.119 97.6712 270.775 97.5286 270.521 97.2747C270.267 97.0209 270.124 96.6766 270.124 96.3176L269.98 20.5928C269.98 20.2338 270.123 19.8895 270.377 19.6357C270.631 19.3818 270.975 19.2392 271.334 19.2392L307.603 19.172L326.553 37.9976Z",
    fill: "black"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M330.461 33.9943L330.567 92.2087C330.567 92.5677 330.424 92.912 330.171 93.1659C329.917 93.4197 329.572 93.5623 329.213 93.5623L275.386 93.6583C275.026 93.6583 274.681 93.516 274.426 93.2625C274.17 93.0089 274.026 92.6646 274.023 92.3047L273.889 16.5895C273.889 16.2296 274.031 15.8844 274.285 15.629C274.538 15.3736 274.882 15.2289 275.242 15.2263L311.511 15.1591L330.461 33.9943Z",
    fill: "url(#paint30_linear_559_64061)"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M330.461 33.9943L330.567 92.2087C330.567 92.5677 330.424 92.912 330.171 93.1659C329.917 93.4197 329.572 93.5623 329.213 93.5623L275.386 93.6583C275.026 93.6583 274.681 93.516 274.426 93.2625C274.17 93.0089 274.026 92.6646 274.023 92.3047L273.889 16.5895C273.889 16.2296 274.031 15.8844 274.285 15.629C274.538 15.3736 274.882 15.2289 275.242 15.2263L311.511 15.1591L330.461 33.9943Z",
    fill: "#F0F7FF"
  }))), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M311.539 15.1208V32.6792C311.539 32.8628 311.576 33.0445 311.648 33.2132C311.72 33.382 311.826 33.5343 311.959 33.6609C312.092 33.7875 312.249 33.8858 312.421 33.9497C312.593 34.0137 312.777 34.0419 312.96 34.0328H330.47L311.539 15.1208Z",
    fill: "url(#paint31_linear_559_64061)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M311.539 15.1208V32.6792C311.539 32.8628 311.576 33.0445 311.648 33.2132C311.72 33.382 311.826 33.5343 311.959 33.6609C312.092 33.7875 312.249 33.8858 312.421 33.9497C312.593 34.0137 312.777 34.0419 312.96 34.0328H330.47L311.539 15.1208Z",
    fill: "#F0F7FF"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M332.776 19.8632V86.18L284.478 86.2664C284.119 86.2664 283.775 86.1238 283.521 85.8699C283.267 85.6161 283.125 85.2718 283.125 84.9128L282.981 9.188C282.979 9.00989 283.013 8.8333 283.081 8.66849C283.149 8.50369 283.248 8.35396 283.374 8.22801C283.5 8.10207 283.65 8.00241 283.815 7.93483C283.979 7.86726 284.156 7.83312 284.334 7.8344L320.641 7.7672L332.776 19.8632Z",
    fill: "black"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M343.42 22.6088L343.526 80.8232C343.526 81.1831 343.384 81.5284 343.13 81.7837C342.877 82.0391 342.532 82.1839 342.172 82.1864L288.345 82.2824C287.985 82.2824 287.64 82.1401 287.385 81.8865C287.129 81.633 286.985 81.2887 286.982 80.9288L286.848 5.20399C286.848 5.02624 286.883 4.85022 286.951 4.68599C287.019 4.52177 287.118 4.37255 287.244 4.24686C287.37 4.12116 287.519 4.02145 287.683 3.95343C287.847 3.8854 288.024 3.85039 288.201 3.85039L324.48 3.76399L343.42 22.6088Z",
    fill: "url(#paint32_linear_559_64061)"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M343.42 22.6088L343.526 80.8232C343.526 81.1831 343.384 81.5284 343.13 81.7837C342.877 82.0391 342.532 82.1839 342.172 82.1864L288.345 82.2824C287.985 82.2824 287.64 82.1401 287.385 81.8865C287.129 81.633 286.985 81.2887 286.982 80.9288L286.848 5.20399C286.848 5.02624 286.883 4.85022 286.951 4.68599C287.019 4.52177 287.118 4.37255 287.244 4.24686C287.37 4.12116 287.519 4.02145 287.683 3.95343C287.847 3.8854 288.024 3.85039 288.201 3.85039L324.48 3.76399L343.42 22.6088Z",
    fill: "#F0F7FF"
  }))), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M324.48 3.76399V21.3224C324.48 21.5002 324.515 21.6762 324.584 21.8404C324.652 22.0046 324.751 22.1538 324.877 22.2795C325.003 22.4052 325.152 22.5049 325.316 22.573C325.48 22.641 325.656 22.676 325.834 22.676H343.344L324.48 3.76399Z",
    fill: "url(#paint33_linear_559_64061)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M324.48 3.76399V21.3224C324.48 21.5002 324.515 21.6762 324.584 21.8404C324.652 22.0046 324.751 22.1538 324.877 22.2795C325.003 22.4052 325.152 22.5049 325.316 22.573C325.48 22.641 325.656 22.676 325.834 22.676H343.344L324.48 3.76399Z",
    fill: "#F0F7FF"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M303.955 33.2936H295.555V34.2536H303.955V33.2936Z",
    fill: "url(#paint34_linear_559_64061)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M326.266 33.2937H308.074V34.2537H326.266V33.2937Z",
    fill: "url(#paint35_linear_559_64061)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M336.355 33.2936H331.143V34.2536H336.355V33.2936Z",
    fill: "url(#paint36_linear_559_64061)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M314.927 40.5512H293.951V41.5112H314.927V40.5512Z",
    fill: "url(#paint37_linear_559_64061)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M336.335 40.5512H321.34V41.5112H336.335V40.5512Z",
    fill: "url(#paint38_linear_559_64061)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M301.391 47.8088H293.951V48.7688H301.391V47.8088Z",
    fill: "url(#paint39_linear_559_64061)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M329.012 47.8088H305.453V48.7688H329.012V47.8088Z",
    fill: "url(#paint40_linear_559_64061)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M336.354 47.8088H333.34V48.7688H336.354V47.8088Z",
    fill: "url(#paint41_linear_559_64061)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M314.927 55.0664H293.951V56.0264H314.927V55.0664Z",
    fill: "url(#paint42_linear_559_64061)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M336.337 55.0664H320.219V56.0264H336.337V55.0664Z",
    fill: "url(#paint43_linear_559_64061)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M303.955 62.324H295.555V63.284H303.955V62.324Z",
    fill: "url(#paint44_linear_559_64061)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M326.266 62.3241H308.074V63.2841H326.266V62.3241Z",
    fill: "url(#paint45_linear_559_64061)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M336.355 62.324H331.143V63.284H336.355V62.324Z",
    fill: "url(#paint46_linear_559_64061)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M314.927 69.5816H293.951V70.5416H314.927V69.5816Z",
    fill: "url(#paint47_linear_559_64061)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M335.817 69.5913H321.34V70.5513H335.817V69.5913Z",
    fill: "url(#paint48_linear_559_64061)"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.839 192.692H207.205C208.774 192.733 210.296 192.15 211.435 191.07C212.575 189.99 213.239 188.501 213.282 186.932V121.086C213.239 119.516 212.575 118.028 211.435 116.948C210.296 115.868 208.774 115.284 207.205 115.326H123.839C122.27 115.287 120.75 115.871 119.611 116.951C118.472 118.03 117.807 119.517 117.762 121.086V186.922C117.804 188.493 118.468 189.982 119.607 191.063C120.747 192.145 122.268 192.731 123.839 192.692Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M123.839 192.692H207.205C208.774 192.733 210.296 192.15 211.435 191.07C212.575 189.99 213.239 188.501 213.282 186.932V121.086C213.239 119.516 212.575 118.028 211.435 116.948C210.296 115.868 208.774 115.284 207.205 115.326H123.839C122.27 115.287 120.75 115.871 119.611 116.951C118.472 118.03 117.807 119.517 117.762 121.086V186.922C117.804 188.493 118.468 189.982 119.607 191.063C120.747 192.145 122.268 192.731 123.839 192.692Z",
    fill: "black"
  })))), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M119.751 188.276H203.117C204.686 188.315 206.206 187.73 207.345 186.651C208.484 185.571 209.149 184.085 209.194 182.516V116.67C209.149 115.101 208.484 113.614 207.345 112.535C206.206 111.455 204.686 110.871 203.117 110.91H119.751C118.182 110.871 116.662 111.455 115.523 112.535C114.384 113.614 113.719 115.101 113.674 116.67V182.506C113.717 184.077 114.38 185.566 115.519 186.647C116.659 187.729 118.18 188.315 119.751 188.276Z",
    fill: "url(#paint49_linear_559_64061)"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.751 188.276H203.117C204.686 188.315 206.206 187.73 207.345 186.651C208.484 185.571 209.149 184.085 209.194 182.516V116.67C209.149 115.101 208.484 113.614 207.345 112.535C206.206 111.455 204.686 110.871 203.117 110.91H119.751C118.182 110.871 116.662 111.455 115.523 112.535C114.384 113.614 113.719 115.101 113.674 116.67V182.506C113.717 184.077 114.38 185.566 115.519 186.647C116.659 187.729 118.18 188.315 119.751 188.276Z",
    fill: "#F0F7FF"
  }))), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M119.607 114.366C119.316 114.358 119.026 114.408 118.754 114.512C118.482 114.617 118.233 114.774 118.022 114.974C117.811 115.175 117.641 115.415 117.523 115.681C117.404 115.947 117.339 116.234 117.332 116.526V182.65C117.339 182.942 117.404 183.229 117.523 183.495C117.641 183.761 117.811 184.001 118.022 184.202C118.233 184.402 118.482 184.559 118.754 184.664C119.026 184.768 119.316 184.818 119.607 184.81H203.262C203.553 184.818 203.843 184.768 204.115 184.664C204.387 184.559 204.635 184.402 204.847 184.202C205.058 184.001 205.228 183.761 205.346 183.495C205.465 183.229 205.529 182.942 205.537 182.65V116.526C205.529 116.234 205.465 115.947 205.346 115.681C205.228 115.415 205.058 115.175 204.847 114.974C204.635 114.774 204.387 114.617 204.115 114.512C203.843 114.408 203.553 114.358 203.262 114.366H119.607Z",
    fill: "url(#paint50_linear_559_64061)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M119.607 114.366C119.316 114.358 119.026 114.408 118.754 114.512C118.482 114.617 118.233 114.774 118.022 114.974C117.811 115.175 117.641 115.415 117.523 115.681C117.404 115.947 117.339 116.234 117.332 116.526V182.65C117.339 182.942 117.404 183.229 117.523 183.495C117.641 183.761 117.811 184.001 118.022 184.202C118.233 184.402 118.482 184.559 118.754 184.664C119.026 184.768 119.316 184.818 119.607 184.81H203.262C203.553 184.818 203.843 184.768 204.115 184.664C204.387 184.559 204.635 184.402 204.847 184.202C205.058 184.001 205.228 183.761 205.346 183.495C205.465 183.229 205.529 182.942 205.537 182.65V116.526C205.529 116.234 205.465 115.947 205.346 115.681C205.228 115.415 205.058 115.175 204.847 114.974C204.635 114.774 204.387 114.617 204.115 114.512C203.843 114.408 203.553 114.358 203.262 114.366H119.607Z",
    fill: "black"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M140.353 147.418L117.312 181.095V182.65C117.32 182.942 117.385 183.229 117.503 183.495C117.622 183.761 117.791 184.001 118.003 184.202C118.214 184.402 118.463 184.559 118.735 184.664C119.007 184.768 119.296 184.818 119.588 184.81H165.898L140.353 147.418Z",
    fill: "url(#paint51_linear_559_64061)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M205.537 175.738L181.786 136.551L152.535 184.81H203.262C203.553 184.818 203.843 184.768 204.115 184.664C204.387 184.559 204.635 184.402 204.847 184.202C205.058 184.001 205.228 183.761 205.346 183.495C205.465 183.229 205.529 182.942 205.537 182.65V175.738Z",
    fill: "url(#paint52_linear_559_64061)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M205.537 175.738L181.786 136.551L152.535 184.81H203.262C203.553 184.818 203.843 184.768 204.115 184.664C204.387 184.559 204.635 184.402 204.847 184.202C205.058 184.001 205.228 183.761 205.346 183.495C205.465 183.229 205.529 182.942 205.537 182.65V175.738Z",
    fill: "#F0F7FF"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M167.385 130.906C167.449 132.097 167.154 133.28 166.538 134.301C165.922 135.323 165.014 136.136 163.931 136.636C162.848 137.136 161.641 137.299 160.464 137.106C159.287 136.912 158.195 136.37 157.33 135.549C156.465 134.728 155.865 133.667 155.609 132.502C155.354 131.337 155.453 130.122 155.895 129.014C156.337 127.907 157.101 126.957 158.088 126.288C159.076 125.619 160.241 125.261 161.433 125.262C162.196 125.236 162.957 125.362 163.67 125.633C164.384 125.904 165.036 126.314 165.59 126.839C166.144 127.364 166.588 127.994 166.896 128.693C167.204 129.391 167.371 130.143 167.385 130.906Z",
    fill: "#F0F7FF"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M147.986 109.018C148.341 108.951 148.725 109.326 148.831 109.873C148.936 110.42 148.754 110.919 148.389 110.986C148.024 111.054 147.659 110.67 147.544 110.122C147.429 109.575 147.631 109.076 147.986 109.018Z",
    fill: "#263238"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M148.695 116.209C149.16 116.232 149.625 116.153 150.056 115.977C150.487 115.801 150.875 115.533 151.191 115.191C149.828 113.986 148.639 112.596 147.658 111.063L148.695 116.209Z",
    fill: "#932A2A"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M145.172 107.444C145.43 107.12 145.764 106.863 146.143 106.696C146.523 106.528 146.937 106.456 147.351 106.484H147.457C147.505 106.492 147.554 106.49 147.602 106.477C147.649 106.464 147.693 106.441 147.73 106.41C147.767 106.378 147.798 106.339 147.818 106.294C147.839 106.25 147.849 106.202 147.849 106.153C147.849 106.104 147.839 106.056 147.818 106.011C147.798 105.967 147.767 105.928 147.73 105.896C147.693 105.864 147.649 105.841 147.602 105.829C147.554 105.816 147.505 105.813 147.457 105.822C146.945 105.768 146.428 105.838 145.949 106.025C145.469 106.212 145.042 106.511 144.702 106.897C144.654 106.958 144.624 107.031 144.615 107.108C144.615 107.196 144.649 107.28 144.71 107.342C144.771 107.405 144.854 107.442 144.942 107.444C145.016 107.472 145.098 107.472 145.172 107.444Z",
    fill: "#263238"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M142.917 125.914C141.957 129.831 141.899 134.698 146.171 136.033C146.171 136.033 151.518 140.506 141.227 140.506C131.877 140.506 130.494 135.399 130.494 135.399C134.017 132.039 133.374 125.07 132.414 120.039L142.917 125.914Z",
    fill: "#B55B52"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M126.719 134.535C126.719 134.535 128.418 130.052 130.712 128.727C133.007 127.402 142.712 129.37 144.21 130.052C145.708 130.734 147.09 134.324 147.09 134.324L126.719 134.535Z",
    fill: "url(#paint53_linear_559_64061)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M126.719 134.535C126.719 134.535 128.418 130.052 130.712 128.727C133.007 127.402 142.712 129.37 144.21 130.052C145.708 130.734 147.09 134.324 147.09 134.324L126.719 134.535Z",
    fill: "#263238"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M141.427 335.77C141.393 335.764 141.362 335.746 141.339 335.72C141.317 335.694 141.304 335.661 141.302 335.626C141.294 335.596 141.296 335.563 141.308 335.533C141.32 335.504 141.342 335.479 141.369 335.463C141.504 335.406 143.913 334.042 145.046 334.35C145.155 334.373 145.258 334.418 145.349 334.482C145.44 334.547 145.516 334.629 145.574 334.724C145.649 334.827 145.689 334.952 145.689 335.079C145.689 335.207 145.649 335.331 145.574 335.434C145.286 335.838 144.47 335.962 143.548 335.962C142.837 335.956 142.128 335.892 141.427 335.77ZM144.643 334.609C143.694 334.723 142.778 335.023 141.945 335.492C143.222 335.665 144.96 335.655 145.276 335.214C145.353 335.146 145.392 335.06 145.276 334.858C145.246 334.798 145.201 334.745 145.146 334.705C145.091 334.665 145.027 334.639 144.96 334.628C144.855 334.609 144.748 334.609 144.643 334.628V334.609Z",
    fill: "url(#paint54_linear_559_64061)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M141.36 335.732C141.321 335.694 141.297 335.643 141.293 335.588C141.293 335.502 141.447 333.668 142.368 332.929C142.498 332.815 142.651 332.731 142.817 332.683C142.983 332.635 143.158 332.624 143.328 332.65C143.77 332.698 143.933 332.929 143.933 333.111C144.058 333.908 142.416 335.367 141.581 335.751H141.514C141.489 335.761 141.461 335.764 141.435 335.761C141.408 335.758 141.382 335.748 141.36 335.732ZM143.175 332.967C142.96 332.967 142.754 333.05 142.599 333.198C142.069 333.794 141.734 334.537 141.639 335.329C142.493 334.81 143.559 333.639 143.559 333.178C143.559 333.178 143.559 332.986 143.242 332.986H143.146L143.175 332.967Z",
    fill: "url(#paint55_linear_559_64061)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M134.592 319.652H141.475L140.784 335.578H133.91L134.592 319.652Z",
    fill: "#B55B52"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M142.408 335.329C147.054 338.209 148.494 338.324 153.88 339.505C155.051 339.754 154.274 342.615 151.451 342.615C146.776 342.615 146.296 342.394 142.312 342.394C138.904 342.394 134.987 342.558 132.27 342.596C132.187 342.605 132.104 342.605 132.021 342.596C131.893 342.569 131.772 342.517 131.665 342.441C131.558 342.366 131.468 342.27 131.399 342.158C131.331 342.047 131.286 341.922 131.268 341.793C131.249 341.664 131.257 341.532 131.291 341.406L132.635 335.29C132.666 335.156 132.742 335.036 132.85 334.95C132.958 334.865 133.092 334.819 133.23 334.82H140.747C141.337 334.834 141.912 335.01 142.408 335.329Z",
    fill: "#263238"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M150.769 134.43C143.927 133.922 137.064 133.765 130.206 133.959C128.408 134.081 126.622 134.257 124.849 134.487C123.958 134.594 123.099 134.881 122.322 135.329C121.545 135.778 120.867 136.379 120.329 137.097C119.79 137.815 119.403 138.634 119.19 139.505C118.977 140.377 118.943 141.282 119.089 142.167C123.169 166.628 120.462 190.618 119.896 195.438L156.683 195.236C160.523 164.967 160.158 149.559 158.68 142.148C158.295 140.213 157.334 138.44 155.922 137.062C154.509 135.684 152.713 134.766 150.769 134.43Z",
    fill: "#263238"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M134.584 319.662L134.238 327.87H141.121L141.477 319.662H134.584Z",
    fill: "black"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M128.984 108.404C129.452 105.976 130.864 103.832 132.91 102.445C134.957 101.057 137.471 100.538 139.899 101.002C146.984 102.337 149.903 112.071 149.691 118.369C149.49 125.358 141.819 130.09 135.695 125.972C131.634 123.217 130.895 119.252 129.167 112.676C128.775 111.285 128.713 109.823 128.984 108.404Z",
    fill: "#B55B52"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M119.922 195.236C119.922 195.236 114.104 208.916 108.642 231.908C101.528 261.879 84.3828 323.108 84.3828 323.108L96.5172 325.767C96.5172 325.767 121.544 254.487 128.12 233.002C132.273 220.007 137.474 207.37 143.672 195.217L119.922 195.236Z",
    fill: "url(#paint56_linear_559_64061)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M135.802 211.46C124.973 240.894 122.688 249.726 122.516 250.302C123.831 232.388 129.236 212.391 135.802 211.46C136.263 211.383 135.36 211.316 135.802 211.46Z",
    fill: "black"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M132.479 195.236C132.479 195.236 132.911 211.374 132.392 234.75C131.932 256.186 132.392 326.276 132.392 326.276H144.095C144.095 326.276 153.051 254.775 155.423 232.974C156.801 220.445 157.237 207.83 156.728 195.236H132.479Z",
    fill: "url(#paint57_linear_559_64061)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M130.715 322.158L131.099 326.468H145.278C145.278 326.468 145.988 321.668 145.931 321.668L130.715 322.158Z",
    fill: "url(#paint58_linear_559_64061)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0482 335.684C84.0409 335.716 84.0241 335.745 84.0002 335.767C83.9762 335.789 83.9461 335.804 83.9138 335.809C83.8819 335.817 83.8483 335.813 83.8187 335.799C83.789 335.785 83.765 335.762 83.7506 335.732C83.6834 335.607 82.3298 333.188 82.6562 332.055C82.7101 331.841 82.8441 331.655 83.0306 331.537C83.1359 331.462 83.2616 331.423 83.3906 331.423C83.5195 331.423 83.6453 331.462 83.7506 331.537C84.1442 331.834 84.2594 332.65 84.2594 333.572C84.2466 334.281 84.176 334.987 84.0482 335.684ZM82.925 332.468C83.0281 333.412 83.3117 334.328 83.7602 335.166C83.9522 333.889 83.9522 332.151 83.5106 331.834C83.453 331.758 83.357 331.719 83.1554 331.834C83.0947 331.865 83.0422 331.91 83.0022 331.965C82.9622 332.02 82.9357 332.084 82.925 332.151C82.9059 332.256 82.9059 332.363 82.925 332.468Z",
    fill: "url(#paint59_linear_559_64061)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0378 335.751C84.0196 335.774 83.9958 335.791 83.9688 335.801C83.9418 335.811 83.9126 335.814 83.8842 335.809C83.817 335.809 81.9642 335.646 81.2442 334.724C81.1376 334.6 81.0586 334.454 81.0122 334.297C80.9659 334.14 80.9534 333.974 80.9754 333.812C80.9754 333.37 81.2442 333.207 81.4362 333.207C82.2138 333.092 83.6826 334.743 84.057 335.578V335.636C84.065 335.675 84.0582 335.716 84.0378 335.751ZM81.2634 333.946C81.2764 334.155 81.3573 334.354 81.4938 334.513C82.0846 335.045 82.8259 335.38 83.6154 335.473C83.1066 334.618 81.945 333.495 81.4746 333.553C81.4746 333.553 81.2922 333.553 81.2922 333.86V333.966L81.2634 333.946Z",
    fill: "url(#paint60_linear_559_64061)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0518 322.474L93.7526 322.983L90.6614 336.164L83.9414 335.684L87.0518 322.474Z",
    fill: "#B55B52"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M87.129 322.11L85.7754 327.908L92.4858 328.388L93.849 322.57L87.129 322.11Z",
    fill: "black"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3298 334.801C80.5154 336.942 79.5554 338.046 74.2946 339.706C73.1426 340.062 74.1794 342.836 76.9922 342.586C81.6482 342.174 79.0754 342.183 83.0402 341.838C86.4386 341.53 90.3554 341.348 93.053 341.156C93.1446 341.155 93.2354 341.139 93.3218 341.108C93.4505 341.073 93.5707 341.013 93.6746 340.929C93.7785 340.846 93.8638 340.741 93.9253 340.623C93.9867 340.505 94.0228 340.375 94.0313 340.242C94.0398 340.109 94.0205 339.976 93.9746 339.85L92.0546 333.87C92.0135 333.74 91.9291 333.628 91.8156 333.553C91.702 333.478 91.5661 333.444 91.4306 333.457L83.9426 334.119C83.3369 334.128 82.7585 334.373 82.3298 334.801Z",
    fill: "#263238"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9344 320.871L82.8672 325.21L97.4592 326.775C97.4592 326.775 98.7072 322.042 98.6592 322.042L82.9344 320.871Z",
    fill: "url(#paint61_linear_559_64061)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M183.744 186.298L187.661 183.13C188.131 183.13 191.434 185.358 192.663 186.289C194.832 187.911 196.426 186.289 198.192 188.804C199.008 189.956 193.479 192.097 192.432 192.519C188.573 193.969 183.744 186.298 183.744 186.298Z",
    fill: "#B55B52"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M187.67 183.121L187.555 183.332C187.163 184.071 186.618 184.717 185.955 185.227C185.293 185.737 184.529 186.099 183.715 186.289L172.195 179.569C169.583 177.87 164.217 174.327 163.468 172.753C160.876 170.257 148.886 158.19 146.188 145.873C145.753 144.006 145.941 142.048 146.725 140.298C147.509 138.549 148.844 137.104 150.527 136.186C153.139 134.881 155.558 135.524 157.411 138.308C160.358 146.305 169.766 166.148 169.766 166.148L187.67 183.121Z",
    fill: "#263238"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M109.796 133.892C109.527 133.738 109.94 124.657 109.94 124.657L115.23 129.639L113.809 134.324C113.809 134.324 113.425 135.918 109.796 133.892Z",
    fill: "#B55B52"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M109.941 124.657L112.226 122.238C112.429 122.016 112.681 121.845 112.963 121.739C113.244 121.633 113.546 121.594 113.845 121.626C114.143 121.657 114.431 121.759 114.683 121.922C114.936 122.085 115.146 122.305 115.298 122.564L116.815 125.07C117.006 125.375 117.107 125.727 117.107 126.087C117.107 126.447 117.006 126.8 116.815 127.105L115.202 129.639C115.202 129.639 110.556 128.41 109.941 124.657Z",
    fill: "#B55B52"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M116.439 162.231C115.976 163.223 115.357 164.133 114.605 164.929C114.019 165.465 113.347 165.899 112.618 166.215C112.242 166.362 111.853 166.474 111.457 166.551C110.815 166.629 110.165 166.498 109.604 166.177C108.714 165.697 107.99 164.961 107.526 164.063C107.062 163.166 106.879 162.149 107.002 161.146C107.377 157.633 108.049 150.01 108.557 135.62C108.552 135.384 108.595 135.149 108.682 134.929C108.77 134.71 108.901 134.51 109.068 134.342C109.235 134.175 109.434 134.043 109.653 133.954C109.872 133.865 110.107 133.821 110.343 133.825L113.77 133.959C114.279 133.959 114.768 134.161 115.128 134.522C115.488 134.882 115.69 135.37 115.69 135.879L115.825 140.151L116.439 162.231Z",
    fill: "#263238"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M107.635 159.86L115.728 140.142L116.304 138.75C116.806 137.559 117.647 136.543 118.722 135.828C119.798 135.112 121.06 134.73 122.352 134.727L126.653 134.842C126.653 134.842 120.595 154.513 116.438 162.231C115.975 163.223 115.356 164.133 114.605 164.929C114.018 165.465 113.347 165.899 112.618 166.215C112.241 166.362 111.853 166.474 111.456 166.551C110.824 166.634 110.181 166.513 109.622 166.206C108.819 165.764 108.174 165.083 107.778 164.256C107.382 163.43 107.255 162.5 107.414 161.598L107.635 159.86Z",
    fill: "#263238"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M129.37 112.551C127.534 112.304 125.863 111.361 124.702 109.918C123.541 108.475 122.978 106.641 123.13 104.794C125.331 101.937 128.258 99.7224 131.607 98.3816C135.272 97.0926 139.224 96.8467 143.021 97.6712C143.925 99.1238 144.589 100.712 144.989 102.375C145.244 103.176 145.314 104.023 145.194 104.855C145.075 105.686 144.768 106.479 144.298 107.175C141.034 111.476 134.717 113.271 129.37 112.551Z",
    fill: "#263238"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M126.136 112.705L132.856 123.486L140.306 123.572L143.685 115.172L144.587 107.05C144.587 107.05 126.779 112.695 124.725 109.93C122.671 107.166 126.136 112.705 126.136 112.705Z",
    fill: "#263238"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.136 112.705L132.856 123.486L140.306 123.572L143.685 115.172L144.587 107.05C144.587 107.05 126.779 112.695 124.725 109.93C122.671 107.166 126.136 112.705 126.136 112.705Z",
    fill: "#F0F7FF"
  }))), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M144.001 109.758C145.921 110.353 146.958 113.262 147.025 115.105C147.092 117.13 145.719 118.398 143.972 117.025C142.649 115.963 141.711 114.496 141.303 112.849C140.843 110.852 142.081 109.162 144.001 109.758Z",
    fill: "#B55B52"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M344.553 113.607H240.191C238.251 113.607 236.678 115.18 236.678 117.121V189.207C236.678 191.148 238.251 192.721 240.191 192.721H344.553C346.493 192.721 348.067 191.148 348.067 189.207V117.121C348.067 115.18 346.493 113.607 344.553 113.607Z",
    fill: "black"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M348.557 108.058H244.195C242.255 108.058 240.682 109.632 240.682 111.572V183.658C240.682 185.599 242.255 187.172 244.195 187.172H348.557C350.497 187.172 352.07 185.599 352.07 183.658V111.572C352.07 109.632 350.497 108.058 348.557 108.058Z",
    fill: "url(#paint62_linear_559_64061)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M348.557 108.058H244.195C242.255 108.058 240.682 109.632 240.682 111.572V183.658C240.682 185.599 242.255 187.172 244.195 187.172H348.557C350.497 187.172 352.07 185.599 352.07 183.658V111.572C352.07 109.632 350.497 108.058 348.557 108.058Z",
    fill: "#F0F7FF"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M348.548 110.708H244.206C243.723 110.708 243.332 111.099 243.332 111.582V183.658C243.332 184.141 243.723 184.532 244.206 184.532H348.548C349.031 184.532 349.422 184.141 349.422 183.658V111.582C349.422 111.099 349.031 110.708 348.548 110.708Z",
    fill: "url(#paint63_linear_559_64061)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M348.548 110.708H244.206C243.723 110.708 243.332 111.099 243.332 111.582V183.658C243.332 184.141 243.723 184.532 244.206 184.532H348.548C349.031 184.532 349.422 184.141 349.422 183.658V111.582C349.422 111.099 349.031 110.708 348.548 110.708Z",
    fill: "black"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M310.079 147.61C310.081 150.313 309.282 152.955 307.782 155.203C306.282 157.45 304.149 159.203 301.653 160.238C299.157 161.274 296.41 161.546 293.759 161.02C291.109 160.494 288.674 159.193 286.762 157.283C284.851 155.373 283.549 152.939 283.021 150.289C282.493 147.639 282.763 144.891 283.797 142.395C284.83 139.898 286.581 137.764 288.828 136.262C291.075 134.761 293.716 133.959 296.419 133.959C300.04 133.959 303.513 135.397 306.075 137.957C308.636 140.517 310.077 143.989 310.079 147.61Z",
    fill: "url(#paint64_linear_559_64061)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M303.523 147.61L292.762 154.58V140.65L303.523 147.61Z",
    fill: "#F0F7FF"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M335.962 173.127H248.506V173.866H335.962V173.127Z",
    fill: "#F0F7FF"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M282.048 173.492C282.048 173.747 281.947 173.991 281.767 174.171C281.587 174.351 281.342 174.452 281.088 174.452H247.737C247.483 174.452 247.239 174.351 247.059 174.171C246.879 173.991 246.777 173.747 246.777 173.492C246.777 173.237 246.879 172.993 247.059 172.813C247.239 172.633 247.483 172.532 247.737 172.532H281.059C281.314 172.532 281.558 172.633 281.738 172.813C281.918 172.993 282.019 173.237 282.019 173.492H282.048Z",
    fill: "url(#paint65_linear_559_64061)"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M343.93 171.332H345.053V172.302H346.003V170.737H343.93V171.332Z",
    fill: "#F0F7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.13 172.302V171.332H339.253V170.737H337.18V172.302H338.13Z",
    fill: "#F0F7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.253 175.662H338.13V174.692H337.18V176.247H339.253V175.662Z",
    fill: "#F0F7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.053 174.692V175.662H343.93V176.247H346.003V174.692H345.053Z",
    fill: "#F0F7FF"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M294.289 181.335L297.505 179.262L294.289 177.178V181.335Z",
    fill: "#F0F7FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M297.504 177.399V179.262V181.114H298.368V177.399H297.504Z",
    fill: "#F0F7FF"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M302.813 177.399H301.689V181.114H302.813V177.399Z",
    fill: "#F0F7FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M304.809 177.399H303.686V181.114H304.809V177.399Z",
    fill: "#F0F7FF"
  }))), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M291.148 179.262L287.932 181.335V177.178L291.148 179.262Z",
    fill: "#F0F7FF"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M365.299 147.082L371.817 163.402C371.946 163.634 372.022 163.891 372.04 164.155C372.058 164.419 372.016 164.684 371.919 164.93C371.821 165.177 371.67 165.398 371.477 165.579C371.283 165.76 371.052 165.895 370.799 165.975L352.156 175.066L355.161 178.906C355.161 178.906 374.054 173.684 377.951 168.98C380.774 165.572 372.835 144.452 372.835 144.452L365.299 147.082Z",
    fill: "#B55B52"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M352.155 175.086L350.945 175.162C349.814 175.234 348.709 175.534 347.697 176.046C346.686 176.557 345.788 177.269 345.061 178.138L343.822 179.617C343.693 179.724 343.589 179.858 343.518 180.01C343.447 180.162 343.41 180.328 343.41 180.495C343.41 180.663 343.447 180.829 343.518 180.98C343.589 181.132 343.693 181.266 343.822 181.374C344.571 182.007 344.35 182.199 344.907 182.66C345.214 182.919 345.32 182.727 345.704 182.593L350.101 181.988C351.936 181.241 353.643 180.211 355.16 178.935L352.155 175.086Z",
    fill: "#B55B52"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M360.192 144.884C363.076 148.045 365.72 151.418 368.102 154.974L376.185 151.911L374.534 143.271C374.15 140.622 371.52 136.839 369.36 136.071C363.244 133.911 360 140.622 360.192 144.884Z",
    fill: "url(#paint66_linear_559_64061)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M329.999 116.084C330.357 115.9 330.753 115.803 331.156 115.803C331.558 115.803 331.955 115.9 332.313 116.084L332.399 116.142C332.479 116.174 332.569 116.174 332.65 116.142C332.73 116.11 332.795 116.048 332.831 115.969C332.863 115.89 332.863 115.801 332.831 115.722C332.798 115.643 332.736 115.58 332.658 115.546C332.221 115.302 331.731 115.165 331.23 115.148C330.729 115.132 330.231 115.235 329.778 115.45C329.707 115.48 329.649 115.535 329.615 115.604C329.597 115.643 329.587 115.685 329.586 115.728C329.585 115.771 329.592 115.814 329.607 115.854C329.622 115.894 329.645 115.931 329.674 115.962C329.704 115.993 329.739 116.018 329.778 116.036C329.843 116.079 329.922 116.096 329.999 116.084Z",
    fill: "#263238"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M330.833 118.282C330.554 119.725 330.123 121.135 329.547 122.487C329.762 122.7 330.033 122.848 330.328 122.916C330.623 122.984 330.931 122.968 331.217 122.871L330.833 118.282Z",
    fill: "#932A2A"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M350.266 123.601C350.189 128.401 350.832 137.194 354.682 139.729C354.682 139.729 354.25 144.721 345.543 146.295C335.943 148.023 340.119 142.369 340.119 142.369C345.12 140.17 344.285 136.321 342.701 132.846L350.266 123.601Z",
    fill: "#B55B52"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M330.345 116.718C329.923 116.718 329.625 117.303 329.683 117.946C329.741 118.59 330.125 119.089 330.547 119.06C330.969 119.031 331.267 118.474 331.209 117.822C331.152 117.169 330.768 116.679 330.345 116.718Z",
    fill: "#263238"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M329.885 117.361C329.737 117.335 329.598 117.269 329.483 117.171C329.368 117.074 329.282 116.947 329.232 116.804C329.517 116.909 329.823 116.946 330.125 116.91C329.998 117.03 329.914 117.188 329.885 117.361Z",
    fill: "#263238"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M353.029 113.06C353.212 121.028 353.452 124.398 349.794 128.794C344.284 135.418 334.434 133.902 331.919 126.193C329.625 119.214 328.837 108.961 336.354 105.159C341.692 102.423 349.093 102.942 351.829 108.27C352.592 109.753 353.003 111.392 353.029 113.06Z",
    fill: "#B55B52"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M362.39 132.058C361.574 129.418 363.014 126.894 362.918 124.234C362.875 122.858 362.559 121.504 361.987 120.251C361.415 118.999 360.599 117.872 359.587 116.938C358.109 115.566 356.352 114.692 355.353 112.849C354.557 111.38 353.933 109.825 353.155 108.337C352.429 106.751 351.277 105.397 349.828 104.426C348.38 103.455 346.69 102.905 344.947 102.836C334.32 102.49 331.785 106.484 331.574 110.746C331.633 113.103 332.348 115.397 333.638 117.37C335.721 120.327 335.049 125.876 333.398 129.063C333.168 129.937 333.173 130.855 333.415 131.726C333.656 132.596 334.124 133.387 334.771 134.017C336.998 136.042 345.504 130.455 353.117 130.618C360.729 130.782 362.39 132.058 362.39 132.058Z",
    fill: "#263238"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M336.689 118.964C336.814 120.469 336.505 121.979 335.796 123.313C334.836 125.031 333.531 124.532 333.07 122.804C332.648 121.287 332.648 118.551 333.934 117.37C335.22 116.19 336.516 117.092 336.689 118.964Z",
    fill: "#B55B52"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M326.677 109.105C326.49 109.819 326.575 110.577 326.918 111.231C327.261 111.884 327.836 112.386 328.53 112.638C328.647 113.308 328.903 113.947 329.283 114.513C329.662 115.078 330.156 115.557 330.733 115.919C331.309 116.281 331.956 116.518 332.63 116.614C333.304 116.711 333.991 116.664 334.645 116.478C333.34 116.113 332.985 114.337 333.455 113.06C334.319 110.718 337.737 107.866 334.482 105.898C331.996 104.42 327.359 106.359 326.677 109.105Z",
    fill: "#263238"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M330.402 150.644C332.264 157.738 334.789 170.218 337.122 191.166L364.107 187.978C362.6 175.959 364.933 166.916 368.379 144.778C368.523 143.867 368.483 142.937 368.263 142.042C368.042 141.146 367.644 140.304 367.093 139.564C366.542 138.825 365.849 138.203 365.055 137.735C364.26 137.267 363.38 136.962 362.466 136.839C360.588 136.59 358.695 136.488 356.802 136.532C351.863 136.58 346.934 136.993 342.056 137.77C340.332 138.087 338.627 138.501 336.949 139.009C334.561 139.72 332.543 141.331 331.322 143.502C330.1 145.673 329.77 148.234 330.402 150.644Z",
    fill: "url(#paint67_linear_559_64061)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M338.706 149.262L334.079 168.788L330.037 149.262C331.199 149.204 338.706 149.262 338.706 149.262Z",
    fill: "black"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M328.117 144.548L336.844 146.084C336.844 146.084 332.898 163.921 329.24 170.602C325.765 176.967 305.164 186.164 305.164 186.164L304.117 182.487L320.197 169.306C321.771 168.011 322.879 166.239 323.356 164.257L328.117 144.548Z",
    fill: "#B55B52"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M304.117 182.487L306.997 184.522L301.592 189.322C299.816 191.06 295.755 190.81 293.077 190.983C292.906 191.002 292.734 190.987 292.569 190.94C292.404 190.892 292.251 190.812 292.117 190.705L291.07 189.898C290.168 189.188 289.938 187.354 291.07 187.134L297.445 186.423C298.616 185.31 304.117 182.487 304.117 182.487Z",
    fill: "#B55B52"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M325.438 146.266C324.622 151.882 324.238 157.306 324.238 157.306L333.838 159.438C333.838 159.438 340.961 148.638 338.638 144.404C336.853 140.718 332.638 138.452 328.779 140.871C327.866 141.476 327.094 142.271 326.517 143.203C325.941 144.134 325.572 145.179 325.438 146.266Z",
    fill: "url(#paint68_linear_559_64061)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M415.689 229.93L418.051 236.574L403.526 244.35L399.82 237.726L415.689 229.93Z",
    fill: "#B55B52"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M414.92 237.735L411.253 232.561C411.174 232.45 411.136 232.314 411.149 232.179C411.161 232.043 411.222 231.916 411.32 231.822L417.359 225.246C417.589 225.049 417.887 224.951 418.189 224.973C418.491 224.994 418.772 225.134 418.972 225.361C419 225.394 419.026 225.429 419.048 225.466C420.623 227.732 421.266 228.903 423.311 231.735C424.559 233.463 429.186 238.196 430.424 240.884C431.663 243.572 429.061 244.935 428.303 243.927C425.893 240.663 420.94 238.58 417.061 238.618C416.298 238.464 415.571 238.164 414.92 237.735Z",
    fill: "#263238"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M395.328 239.799L399.168 246.788L408.499 241.681L405.437 234.961L395.328 239.799Z",
    fill: "black"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M322.926 240.798C328.782 243.063 335.406 241.652 341.396 239.838C350.929 236.89 360.673 233.694 368.708 227.838C374.209 223.825 375.841 219.198 374.699 217.278C367.647 216.128 360.499 215.674 353.358 215.924C346.311 216.298 339.169 218.18 333.582 222.423C327.995 226.666 323.675 239.703 323.934 239.29L322.926 240.798Z",
    fill: "url(#paint69_linear_559_64061)"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M322.926 240.798C328.782 243.063 335.406 241.652 341.396 239.838C350.929 236.89 360.673 233.694 368.708 227.838C374.209 223.825 375.841 219.198 374.699 217.278C367.647 216.128 360.499 215.674 353.358 215.924C346.311 216.298 339.169 218.18 333.582 222.423C327.995 226.666 323.675 239.703 323.934 239.29L322.926 240.798Z",
    fill: "black"
  }))), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M342.806 188.583C342.806 188.583 337.449 264.539 362.534 270.913C378.24 274.647 406.435 245.684 406.435 245.684L402.057 236.295C402.057 236.295 377.51 246.087 372.844 243.803C361.555 221.521 376.06 201.937 363.792 186.807L342.806 188.583Z",
    fill: "#263238"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M416.927 238.254C416.906 238.23 416.878 238.212 416.847 238.204C416.817 238.195 416.784 238.196 416.754 238.206C416.722 238.214 416.693 238.232 416.672 238.258C416.651 238.284 416.64 238.316 416.639 238.35C416.639 238.609 416.408 241.182 417.128 241.719C417.208 241.78 417.302 241.819 417.401 241.833C417.501 241.846 417.602 241.834 417.695 241.796C417.851 241.75 417.992 241.665 418.107 241.549C418.221 241.433 418.304 241.29 418.347 241.134V241.047C418.482 240.231 417.522 238.964 416.927 238.254ZM416.927 238.81C417.743 239.77 418.117 240.615 418.011 241.047C417.98 241.151 417.923 241.244 417.846 241.32C417.769 241.395 417.674 241.45 417.57 241.479C417.531 241.503 417.486 241.516 417.44 241.516C417.394 241.516 417.35 241.503 417.311 241.479C416.917 241.191 416.869 239.828 416.927 238.801V238.81Z",
    fill: "url(#paint70_linear_559_64061)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M416.985 238.378C416.985 238.35 416.978 238.322 416.965 238.297C416.951 238.272 416.932 238.25 416.908 238.234C416.884 238.218 416.856 238.209 416.826 238.209C416.797 238.209 416.769 238.218 416.745 238.234C416.668 238.234 414.882 239.194 414.642 240.231C414.604 240.355 414.594 240.485 414.612 240.613C414.631 240.74 414.677 240.863 414.748 240.97C414.814 241.087 414.917 241.177 415.041 241.228C415.164 241.278 415.301 241.286 415.43 241.249C416.121 241.018 416.793 239.502 416.927 238.638C416.955 238.553 416.974 238.467 416.985 238.378ZM414.93 240.375C414.934 240.359 414.934 240.343 414.93 240.327C415.074 239.713 416.006 239.05 416.582 238.695C416.418 239.54 415.785 240.788 415.314 240.932C415.238 240.932 415.132 240.932 415.017 240.778C414.973 240.722 414.942 240.656 414.926 240.587C414.909 240.518 414.908 240.445 414.921 240.375H414.93Z",
    fill: "url(#paint71_linear_559_64061)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M362.821 333.111L355.909 334.388L352.338 318.414L359.25 317.137L362.821 333.111Z",
    fill: "#B55B52"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M353.221 335.703C353.254 335.691 353.283 335.671 353.305 335.644C353.327 335.617 353.341 335.584 353.346 335.55C353.343 335.515 353.33 335.481 353.31 335.453C353.29 335.424 353.263 335.401 353.231 335.386C352.905 335.262 349.938 334.158 349.141 334.734C349.066 334.786 349.005 334.857 348.965 334.939C348.925 335.021 348.906 335.112 348.911 335.204C348.909 335.355 348.943 335.504 349.01 335.639C349.077 335.774 349.174 335.891 349.295 335.982C349.838 336.253 350.457 336.334 351.052 336.212C351.788 336.104 352.514 335.934 353.221 335.703ZM349.641 334.906C350.677 334.944 351.7 335.158 352.664 335.54C351.138 335.972 349.976 336.039 349.516 335.713C349.436 335.653 349.371 335.574 349.328 335.484C349.284 335.394 349.263 335.295 349.266 335.194C349.262 335.158 349.269 335.121 349.284 335.087C349.299 335.053 349.323 335.024 349.353 335.002C349.446 334.948 349.551 334.915 349.66 334.906H349.641Z",
    fill: "url(#paint72_linear_559_64061)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M353.279 335.655C353.293 335.629 353.301 335.599 353.301 335.569C353.301 335.539 353.293 335.509 353.279 335.482C353.279 335.415 352.876 333.562 351.916 332.91C351.776 332.817 351.618 332.756 351.453 332.729C351.287 332.703 351.118 332.712 350.956 332.756C350.495 332.862 350.418 333.111 350.39 333.294C350.342 334.11 352.166 335.425 353.049 335.703H353.106C353.137 335.713 353.169 335.714 353.2 335.705C353.231 335.697 353.258 335.679 353.279 335.655ZM351.167 333.063C351.378 333.021 351.597 333.058 351.782 333.169C352.37 333.715 352.767 334.435 352.914 335.223C351.954 334.83 350.745 333.774 350.774 333.303C350.774 333.303 350.774 333.14 351.081 333.073H351.177L351.167 333.063Z",
    fill: "url(#paint73_linear_559_64061)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M356.026 331.546L362.353 331.278C362.489 331.266 362.625 331.306 362.733 331.389C362.842 331.473 362.915 331.594 362.938 331.729L365.194 340.369C365.236 340.668 365.158 340.971 364.979 341.213C364.799 341.455 364.532 341.617 364.234 341.665H364.1C361.345 341.751 360.01 341.665 356.525 341.838C354.394 341.943 347.885 343.278 345.005 342.855C342.125 342.433 342.337 339.514 343.594 339.428C347.636 339.159 352.071 336.135 354.154 332.862C354.442 332.574 355.585 331.556 356.026 331.546Z",
    fill: "#263238"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M352.338 318.414L354.181 326.65L361.093 325.383L359.26 317.146L352.338 318.414Z",
    fill: "black"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M359.922 203.454L347.951 216.394L353.26 251.569L359.922 203.454Z",
    fill: "black"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M336.229 189.495C336.229 189.495 329.029 208.225 328.396 225.831C327.321 255.889 335.471 282.846 338.351 292.417C344.246 311.953 350.342 321.812 350.342 321.812L361.794 320.449C361.794 320.449 346.982 235.134 354.114 225.073C369.071 204.02 356.14 187.441 356.14 187.441L336.229 189.495Z",
    fill: "#263238"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M362.929 170.487C373.489 185.012 373.489 205.182 375.044 217.998C373.124 220.753 360.98 224.007 357.61 223.902C350.927 223.749 344.303 225.196 338.292 228.122C332.28 231.047 327.055 235.367 323.05 240.721C320.026 230.362 334.57 175.374 334.57 175.374C337.863 174.385 360.874 167.684 362.929 170.487Z",
    fill: "url(#paint74_linear_559_64061)"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M356.601 143.655L345.6 144.884C344.959 144.943 344.317 144.787 343.776 144.439C343.235 144.091 342.826 143.572 342.614 142.964C342.293 142.287 341.876 141.66 341.376 141.102C340.488 139.935 339.281 139.051 337.9 138.558C341.166 137.39 344.539 136.547 347.971 136.042C353.107 135.514 355.008 136.542 355.008 136.542C357.59 137.262 358.512 138.279 359.03 140.151C359.133 140.543 359.151 140.953 359.08 141.352C359.01 141.751 358.854 142.13 358.623 142.463C358.392 142.796 358.092 143.075 357.743 143.281C357.394 143.487 357.004 143.614 356.601 143.655Z",
    fill: "#B55B52"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M240.709 312.337C240.709 312.337 249.993 303.582 249.839 297.831C249.685 292.081 244.079 305.559 243.906 302.727C243.733 299.895 250.319 291.754 250.626 286.196C250.933 280.638 243.906 296.17 243.589 293.559C243.273 290.948 249.954 279.399 249.897 275.319C249.839 271.239 244.012 285.562 243.177 282.999C242.341 280.436 248.034 271.038 246.575 263.982C245.116 256.926 242.015 275.444 241.545 273.092C241.074 270.74 245.01 258.692 242.226 253.892C239.442 249.092 240.22 266.938 239.269 264.865C238.319 262.791 237.743 252.538 234.191 249.044C230.639 245.55 235.151 259.374 234.037 260.065C232.924 260.756 227.884 250.465 226.521 252.433C225.157 254.401 233.711 265.431 233.797 268.071C233.884 270.711 226.885 263.665 226.261 266.526C225.637 269.386 235.996 273.889 236.524 276.625C237.052 279.361 227.884 274.465 227.941 277.287C227.999 280.11 236.649 281.617 237.167 284.823C237.685 288.03 228.681 282.51 229.17 286.263C229.66 290.017 235.727 289.287 236.418 292.983C237.109 296.679 230.159 292.465 230.428 295.988C230.697 299.511 237.628 299.905 238.357 302.593C239.087 305.281 231.724 301.335 231.935 304.186C232.146 307.038 239.26 307.45 240.709 312.337Z",
    fill: "#2CA63F"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M239.942 324.788C241.166 318.308 241.809 311.731 241.862 305.137C242.207 290.804 240.412 276.337 235.631 262.801C235.286 261.841 233.711 262.167 234.028 263.166C238.611 276.647 240.709 290.848 240.22 305.079C240.152 311.524 239.509 317.949 238.3 324.279C238.089 325.306 239.654 325.806 239.875 324.769L239.942 324.788Z",
    fill: "#2CA63F"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M243.429 315.294C243.429 315.294 236.968 302.938 239.032 294.567C241.096 286.196 242.603 305.684 243.563 301.018C244.523 296.353 240.539 287.29 244.245 280.561C247.95 273.831 244.523 293.194 246.99 288.942C249.457 284.689 246.587 273.841 250.014 269.742C253.441 265.642 251.109 278.66 252.76 276.606C254.411 274.551 253.998 264.932 256.6 262.734C259.201 260.535 256.878 271.93 258.251 269.742C259.624 267.553 262.782 257.521 267.179 256.302C271.576 255.082 264.299 262.484 267.179 261.793C270.059 261.102 276.645 259.594 277.201 262.618C277.758 265.642 263.329 268.897 261.688 272.564C260.046 276.231 268.273 269.684 269.781 272.43C271.288 275.175 257.157 279.015 256.053 283.134C254.949 287.252 267.726 279.706 267.448 283.959C267.169 288.212 252.76 289.038 252.088 292.743C251.416 296.449 263.886 288.625 263.473 292.33C263.061 296.036 250.571 298.926 249.745 302.89C248.92 306.855 258.952 299.185 259.221 302.343C259.489 305.502 243.429 315.294 243.429 315.294Z",
    fill: "#2CA63F"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M243.429 315.294C243.429 315.294 236.968 302.938 239.032 294.567C241.096 286.196 242.603 305.684 243.563 301.018C244.523 296.353 240.539 287.29 244.245 280.561C247.95 273.831 244.523 293.194 246.99 288.942C249.457 284.689 246.587 273.841 250.014 269.742C253.441 265.642 251.109 278.66 252.76 276.606C254.411 274.551 253.998 264.932 256.6 262.734C259.201 260.535 256.878 271.93 258.251 269.742C259.624 267.553 262.782 257.521 267.179 256.302C271.576 255.082 264.299 262.484 267.179 261.793C270.059 261.102 276.645 259.594 277.201 262.618C277.758 265.642 263.329 268.897 261.688 272.564C260.046 276.231 268.273 269.684 269.781 272.43C271.288 275.175 257.157 279.015 256.053 283.134C254.949 287.252 267.726 279.706 267.448 283.959C267.169 288.212 252.76 289.038 252.088 292.743C251.416 296.449 263.886 288.625 263.473 292.33C263.061 296.036 250.571 298.926 249.745 302.89C248.92 306.855 258.952 299.185 259.221 302.343C259.489 305.502 243.429 315.294 243.429 315.294Z",
    fill: "#F0F7FF"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M234.298 314.929C234.298 314.929 240.547 303.793 238.685 298.359C236.822 292.926 235.459 307.47 234.48 304.801C233.501 302.132 237.36 292.417 235.93 287.031C234.499 281.646 232.541 298.551 231.408 296.161C230.275 293.77 233.251 280.743 231.994 276.903C230.736 273.063 229.44 288.423 227.866 286.273C226.291 284.122 228.922 273.409 225.418 267.073C221.914 260.737 224.458 279.37 223.344 277.268C222.23 275.166 222.384 262.474 218.237 258.702C214.09 254.929 220.234 271.758 218.698 270.058C217.162 268.359 213.562 258.759 209.098 256.484C204.634 254.209 213.082 266.084 212.246 267.044C211.411 268.004 203.51 259.738 202.79 262.014C202.07 264.289 213.542 272.257 214.406 274.753C215.27 277.249 206.496 272.612 206.726 275.53C206.957 278.449 218.246 279.649 219.533 282.106C220.819 284.564 210.672 282.625 211.555 285.303C212.438 287.982 221.155 286.83 222.605 289.738C224.054 292.647 213.811 290.065 215.405 293.502C216.998 296.938 222.566 294.462 224.333 297.754C226.099 301.047 218.208 299.137 219.533 302.42C220.858 305.703 227.578 303.994 229.075 306.346C230.573 308.698 222.355 307.124 223.421 309.783C224.486 312.442 231.456 310.695 234.298 314.929Z",
    fill: "#2CA63F"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M234.298 314.929C234.298 314.929 240.547 303.793 238.685 298.359C236.822 292.926 235.459 307.47 234.48 304.801C233.501 302.132 237.36 292.417 235.93 287.031C234.499 281.646 232.541 298.551 231.408 296.161C230.275 293.77 233.251 280.743 231.994 276.903C230.736 273.063 229.44 288.423 227.866 286.273C226.291 284.122 228.922 273.409 225.418 267.073C221.914 260.737 224.458 279.37 223.344 277.268C222.23 275.166 222.384 262.474 218.237 258.702C214.09 254.929 220.234 271.758 218.698 270.058C217.162 268.359 213.562 258.759 209.098 256.484C204.634 254.209 213.082 266.084 212.246 267.044C211.411 268.004 203.51 259.738 202.79 262.014C202.07 264.289 213.542 272.257 214.406 274.753C215.27 277.249 206.496 272.612 206.726 275.53C206.957 278.449 218.246 279.649 219.533 282.106C220.819 284.564 210.672 282.625 211.555 285.303C212.438 287.982 221.155 286.83 222.605 289.738C224.054 292.647 213.811 290.065 215.405 293.502C216.998 296.938 222.566 294.462 224.333 297.754C226.099 301.047 218.208 299.137 219.533 302.42C220.858 305.703 227.578 303.994 229.075 306.346C230.573 308.698 222.355 307.124 223.421 309.783C224.486 312.442 231.456 310.695 234.298 314.929Z",
    fill: "#F0F7FF"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M237.292 327.044C236.534 320.493 235.191 314.022 233.28 307.71C229.462 293.843 223.162 280.784 214.684 269.166C214.051 268.33 212.62 269.166 213.254 270.001C221.66 281.493 227.909 294.416 231.696 308.142C233.57 314.313 234.891 320.638 235.641 327.044C235.747 328.09 237.398 328.1 237.292 327.044Z",
    fill: "#2CA63F"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M243.149 325.46C243.404 319.726 244.074 314.018 245.156 308.382C247.133 297.495 250.292 286.378 256.378 277.028C259.712 271.605 264.502 267.228 270.202 264.394C271.162 263.943 270.327 262.522 269.367 262.964C258.98 267.85 252.749 278.247 248.804 288.606C245.251 298.318 242.973 308.451 242.026 318.75C241.786 320.977 241.575 323.214 241.498 325.47C241.498 326.526 243.111 326.526 243.149 325.47V325.46Z",
    fill: "#2CA63F"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M256.598 316.532H222.557L226.397 333.812V337.719C226.397 339.015 226.911 340.258 227.828 341.174C228.744 342.091 229.987 342.606 231.283 342.606H247.872C249.168 342.606 250.411 342.091 251.327 341.174C252.243 340.258 252.758 339.015 252.758 337.719V333.812L256.598 316.532Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_559_64061)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_559_64061",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 401,
    y: 5,
    width: 49,
    height: 49
  }, _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M401.469 5.78157H449.468V53.7816H401.469V5.78157Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_559_64061)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M404.879 29.781C404.879 37.9309 409.615 44.9732 416.483 48.311L406.661 21.402C405.484 24.0384 404.877 26.8937 404.879 29.781ZM439.367 28.7421C439.367 26.1976 438.453 24.4354 437.669 23.0638C436.625 21.3679 435.647 19.9317 435.647 18.2357C435.647 16.3431 437.082 14.5814 439.104 14.5814C439.195 14.5814 439.282 14.5927 439.371 14.5978C435.708 11.242 430.828 9.19307 425.468 9.19307C418.275 9.19307 411.947 12.8835 408.265 18.4732C408.748 18.4877 409.204 18.4974 409.59 18.4974C411.744 18.4974 415.077 18.2361 415.077 18.2361C416.187 18.1707 416.318 19.8008 415.21 19.9321C415.21 19.9321 414.094 20.0633 412.853 20.1284L420.35 42.4295L424.856 28.9164L421.648 20.128C420.54 20.0629 419.489 19.9317 419.489 19.9317C418.38 19.8667 418.51 18.1703 419.619 18.2357C419.619 18.2357 423.02 18.4971 425.043 18.4971C427.196 18.4971 430.53 18.2357 430.53 18.2357C431.64 18.1703 431.771 19.8005 430.662 19.9317C430.662 19.9317 429.544 20.0629 428.305 20.128L435.746 42.2602L437.799 35.3977C438.689 32.55 439.367 30.5046 439.367 28.7421Z",
    fill: "#00749A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.83 31.5819L419.652 49.5317C421.541 50.0883 423.5 50.3709 425.468 50.3708C427.866 50.3708 430.165 49.956 432.306 49.2038C432.248 49.1139 432.199 49.019 432.159 48.9201L425.83 31.5819ZM443.534 19.903C443.623 20.5588 443.673 21.2632 443.673 22.0201C443.673 24.1094 443.283 26.458 442.107 29.3947L435.818 47.5776C441.939 44.0082 446.056 37.3768 446.056 29.7809C446.062 26.3283 445.194 22.9304 443.534 19.903Z",
    fill: "#00749A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.469 5.78157C412.236 5.78157 401.469 16.5476 401.469 29.781C401.469 43.0159 412.235 53.782 425.469 53.782C438.702 53.782 449.47 43.0163 449.47 29.781C449.47 16.5476 438.702 5.78157 425.469 5.78157ZM425.469 52.6815C412.842 52.6815 402.569 42.4083 402.569 29.781C402.569 17.1548 412.842 6.88243 425.469 6.88243C438.095 6.88243 448.368 17.1548 448.368 29.781C448.368 42.4083 438.095 52.6815 425.469 52.6815Z",
    fill: "#00749A"
  })))), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2727 254.936C37.8907 253.453 35.6437 252.869 33.3967 251.385C32.0028 250.442 30.0708 248.194 28.4519 246.262C28.1377 249.363 27.1938 250.622 26.1157 251.52C23.8233 253.318 22.3848 253.857 20.4074 254.936C18.7443 255.79 9.71094 261.183 9.71094 272.778C9.71094 284.375 19.4639 292.913 30.2951 292.913C41.1277 292.913 50.5203 285.048 50.5203 273.138C50.5203 261.228 41.7112 255.835 40.2727 254.936ZM40.5326 288.684C40.3076 288.909 38.2402 290.347 35.8136 290.572C33.3862 290.796 30.1057 290.932 28.1276 289.134C27.8133 288.819 27.9033 288.37 28.1276 288.19C28.3526 288.01 28.5326 287.875 28.8022 287.875C29.0718 287.875 29.0272 287.875 29.1618 287.965C30.0603 288.684 31.4088 289.268 34.2851 289.268C37.1621 289.268 39.1841 288.459 40.0829 287.785C40.4879 287.47 40.6676 287.741 40.7122 287.92C40.7576 288.1 40.8476 288.37 40.5326 288.684ZM32.6673 284.594C33.1616 284.145 33.9712 283.426 34.7351 283.111C35.4989 282.797 35.9039 282.842 36.6224 282.842C37.3417 282.842 38.1056 282.886 38.6456 283.246C39.1848 283.605 39.4994 284.415 39.6791 284.864C39.8587 285.313 39.6791 285.583 39.3194 285.762C39.0052 285.942 38.9598 285.852 38.6456 285.269C38.3306 284.684 38.0609 284.1 36.4878 284.1C34.9147 284.1 34.4201 284.639 33.6562 285.269C32.8923 285.898 32.6227 286.123 32.3531 285.762C32.0834 285.403 32.1727 285.044 32.6673 284.594ZM44.5777 284.954C42.9599 284.819 39.7233 279.785 37.6556 279.696C35.0497 279.606 29.3857 285.134 24.9363 285.134C22.2401 285.134 21.4312 284.73 20.5319 284.145C19.1834 283.201 18.5096 281.763 18.5546 279.785C18.5996 276.279 21.8804 272.999 26.0152 272.954C31.2738 272.909 34.9139 278.167 37.5663 278.122C39.8133 278.078 44.1281 273.673 46.2404 273.673C48.4874 273.673 49.1174 276.01 49.1174 277.403C49.1174 278.796 48.6678 281.313 47.5889 282.886C46.5101 284.459 45.8362 285.044 44.5777 284.954Z",
    fill: "#0073BA"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_559_64061)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.7966 28.9796C53.8003 27.2762 53.1273 25.6411 51.9257 24.4338C50.724 23.2265 49.092 22.5459 47.3886 22.5416C45.8388 22.5427 44.3412 23.102 43.1703 24.1173C41.9993 25.1325 41.2333 26.5356 41.0126 28.0696C39.1774 27.5301 37.2306 27.4951 35.3772 27.9685C33.5238 28.4419 31.8323 29.4061 30.4806 30.7596C28.5186 32.8056 22.8626 38.4196 19.8086 41.4616L24.5526 46.2056C25.6246 45.1336 34.1646 36.5956 35.2346 35.5136C35.9731 34.7778 36.9731 34.3646 38.0156 34.3646C39.0581 34.3646 40.0581 34.7778 40.7966 35.5136C42.1686 36.8856 42.6186 39.2636 40.4206 41.4476L45.1366 46.1936C48.4806 42.8516 49.2626 38.9516 48.2346 35.3516C49.7729 35.1357 51.1819 34.3727 52.2034 33.2024C53.2249 32.0322 53.7905 30.533 53.7966 28.9796Z",
    fill: "#EE4035"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1472 65.3836C41.4427 66.8393 42.2328 68.1478 43.3833 69.0873C44.5338 70.0267 45.9739 70.5391 47.4592 70.5376C48.3029 70.5363 49.138 70.3687 49.9169 70.0443C50.6957 69.7199 51.4029 69.2452 51.9981 68.6472C52.5932 68.0493 53.0647 67.3398 53.3854 66.5595C53.7061 65.7792 53.8699 64.9433 53.8672 64.0996C53.863 62.5552 53.3012 61.0643 52.2851 59.9013C51.269 58.7382 49.8671 57.9812 48.3372 57.7696L48.3412 57.7656C48.7823 55.9883 48.7545 54.1269 48.2605 52.3635C47.7666 50.6002 46.8234 48.9952 45.5232 47.7056C44.2592 46.3976 46.0572 48.2076 34.8632 37.0256L30.1152 41.7736L40.7972 52.4536C41.533 53.1918 41.9461 54.1914 41.9461 55.2336C41.9461 56.2758 41.533 57.2755 40.7972 58.0136C39.4252 59.3856 37.0452 59.8356 34.8612 57.6396L30.1452 62.3856C31.5026 63.882 33.2594 64.9593 35.2087 65.4904C37.1579 66.0216 39.2184 65.9845 41.1472 65.3836Z",
    fill: "#4F91CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5898 45.8317C18.9578 51.1857 14.8858 47.1717 24.2838 56.5117L28.9998 51.7657L18.3398 41.1077C17.6035 40.3633 17.1906 39.3586 17.1906 38.3117C17.1906 37.2647 17.6035 36.26 18.3398 35.5157C19.7078 34.1417 22.0778 33.6917 24.2738 35.8877L29.0218 31.1417C25.8718 27.9917 22.1758 27.1157 18.6838 27.9277C18.4235 26.3343 17.5722 24.8975 16.2998 23.9039C15.0273 22.9102 13.427 22.4326 11.8181 22.5664C10.2091 22.7001 8.70968 23.4354 7.61871 24.6255C6.52774 25.8156 5.9254 27.3732 5.93177 28.9877L5.92977 28.9917C5.92239 30.4484 6.41532 31.8635 7.32615 33.0004C8.23698 34.1373 9.5105 34.9271 10.9338 35.2377C9.83777 38.8897 10.7178 42.9937 13.5898 45.8317Z",
    fill: "#F9AE40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2733 70.5416C13.7326 70.5451 15.1495 70.0517 16.291 69.1425C17.4324 68.2334 18.2303 66.9627 18.5533 65.5396C20.3333 65.9844 22.198 65.9616 23.9665 65.4735C25.7351 64.9853 27.3475 64.0484 28.6473 62.7536C32.0873 59.3256 29.9553 61.4256 39.3073 52.0736L39.3093 52.0756L34.5933 47.3296C25.2713 56.5856 29.1913 52.7276 23.9113 58.0216C23.1728 58.7575 22.1728 59.1706 21.1303 59.1706C20.0878 59.1706 19.0878 58.7575 18.3493 58.0216C16.9453 56.5856 16.5393 54.2396 18.6933 52.0876L13.9773 47.3416C10.7413 50.5776 9.9053 54.3256 10.8153 57.8736C9.40471 58.1943 8.14558 58.9863 7.24568 60.1189C6.34578 61.2515 5.85887 62.657 5.8653 64.1036C5.8624 64.9474 6.02596 65.7834 6.3466 66.5638C6.66723 67.3443 7.13866 68.0538 7.73388 68.6518C8.3291 69.2498 9.03643 69.7246 9.81537 70.0488C10.5943 70.3731 11.4296 70.5406 12.2733 70.5416Z",
    fill: "#7AC043"
  }))), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M434.944 175.941L433.916 176.092V192.859H436.64V184.415L437.111 184.021C437.401 183.773 437.715 183.556 438.049 183.371C438.715 183.038 439.97 183.038 440.486 183.386C441.273 183.886 441.334 184.309 441.334 188.773V192.859H444.209V188.804C444.209 184.417 444.088 183.508 443.393 182.48C442.198 180.709 439.383 180.392 437.43 181.814C437.081 182.057 436.764 182.268 436.719 182.268C436.688 182.268 436.629 180.815 436.613 179.044C436.568 175.367 436.735 175.685 434.948 175.941H434.944ZM470.111 177.712C469.749 177.773 469.4 177.908 469.34 178.016C469.263 178.121 469.128 178.787 469.038 179.514C468.782 181.346 468.766 181.361 468.266 181.361C467.389 181.361 467.101 181.589 466.844 182.466C466.709 182.921 466.601 183.344 466.601 183.389C466.601 183.434 467.085 183.479 467.661 183.479H468.721V186.732C468.721 188.519 468.797 190.319 468.887 190.757C469.31 192.724 471.686 193.572 473.972 192.557L474.609 192.269L474.382 191.466C474.3 191.172 474.199 190.884 474.078 190.604C474.049 190.559 473.655 190.62 473.23 190.726C472.519 190.877 472.397 190.877 472.049 190.62L471.671 190.332L471.626 186.899L471.594 183.479H474.319V181.208H471.61L471.565 179.422C471.52 177.408 471.565 177.469 470.111 177.712ZM404.254 182.039V183.175H411.366V180.905H404.254V182.039ZM413.938 182.039V183.175H416.208V180.905H413.938V182.039ZM425.199 181.071C424.695 181.222 424.212 181.435 423.761 181.706C423.111 182.084 422.868 182.372 422.506 183.067C421.658 184.716 421.991 186.971 423.248 187.97L423.732 188.363L423.172 188.924C422.477 189.619 422.279 190.436 422.627 191.239C422.735 191.517 422.906 191.765 423.127 191.966C423.399 192.132 423.354 192.193 422.627 192.935C421.75 193.813 421.552 194.357 421.718 195.494C421.869 196.432 422.641 197.294 423.746 197.719C424.472 198.007 424.911 198.068 426.423 198.068C430.419 198.083 432.687 196.553 432.703 193.831C432.703 192.695 432.325 192.044 431.355 191.561C430.523 191.151 430.01 191.061 427.361 190.895C426.18 190.818 425.168 190.683 425.046 190.577C424.925 190.487 424.835 190.215 424.835 189.988C424.835 189.277 425.197 189.126 426.954 189.05C429.254 188.96 430.464 188.354 431.236 186.885C431.492 186.401 431.553 186.037 431.537 185.069C431.532 184.539 431.506 184.009 431.461 183.481C431.416 183.148 431.49 183.087 432.066 182.952L432.716 182.815L432.671 181.908C432.611 180.758 432.444 180.698 431.099 181.364C430.221 181.787 430.115 181.818 429.798 181.607C428.889 181.017 426.635 180.758 425.197 181.078L425.199 181.071ZM427.906 183.083C428.707 183.416 428.981 183.839 429.04 184.914C429.101 185.821 429.085 185.882 428.572 186.442C428.072 186.986 427.996 187.018 427.013 187.076C425.771 187.137 425.091 186.804 424.742 185.972C423.91 183.958 425.816 182.192 427.906 183.083ZM429.602 193.221C430.691 193.689 430.374 195.021 428.997 195.732C428.36 196.049 428.043 196.11 426.878 196.11C425.273 196.11 424.623 195.838 424.306 195.066C424.177 194.734 424.156 194.369 424.245 194.025C424.335 193.68 424.531 193.372 424.805 193.145C425.199 192.843 425.321 192.827 427.15 192.917C428.27 192.962 429.299 193.102 429.602 193.221ZM449.351 181.145C446.837 181.811 445.402 183.931 445.402 186.957C445.402 188.591 445.703 189.695 446.475 190.816C448.412 193.631 453.632 193.707 455.752 190.953C457.295 188.939 457.356 185.279 455.873 183.114C454.631 181.314 451.864 180.482 449.351 181.148V181.145ZM452.06 183.175C453.347 183.537 454.042 184.869 454.042 186.959C454.042 187.594 453.936 188.458 453.815 188.865C453.043 191.468 449.411 191.543 448.534 188.971C448.217 188.048 448.217 185.868 448.518 184.961C449.033 183.463 450.5 182.723 452.06 183.175ZM460.7 181.132C458.884 181.647 457.946 182.781 457.946 184.43C457.946 186.278 458.717 187.108 461.138 187.866C462.817 188.395 463.364 188.699 463.589 189.275C463.845 189.88 463.528 190.44 462.817 190.697C462.196 190.924 460.578 190.834 459.518 190.501C458.382 190.168 458.308 190.184 458.036 191.151C457.793 191.968 457.793 192.013 458.065 192.211C459.048 192.922 462.212 193.181 463.71 192.65C465.285 192.105 466.282 190.789 466.298 189.275C466.298 187.504 465.542 186.716 463.044 185.9C462.494 185.719 461.954 185.512 461.424 185.279C460.502 184.808 460.288 184.084 460.895 183.492C461.411 183.022 462.515 182.932 463.937 183.249C464.588 183.386 465.193 183.476 465.285 183.431C465.391 183.386 465.573 183.008 465.679 182.57C465.877 181.827 465.861 181.753 465.602 181.555C464.831 180.995 462.061 180.754 460.7 181.132ZM404.254 186.881V188.015H416.208V185.744H404.254V186.878V186.881ZM404.254 191.648V192.708H408.945V190.589H404.254V191.648ZM411.517 191.648V192.708H416.208V190.589H411.517V191.648Z",
    fill: "#444444"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_559_64061",
    x1: 95.8184,
    y1: 213.284,
    x2: 400.391,
    y2: 169.433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_559_64061",
    x1: 95.9902,
    y1: 14.6408,
    x2: 150.101,
    y2: -103.189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_559_64061",
    x1: 233.202,
    y1: 92.9864,
    x2: 227.41,
    y2: 12.4923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_559_64061",
    x1: 129.33,
    y1: 70.8776,
    x2: 187.29,
    y2: 63.4581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_559_64061",
    x1: 131.357,
    y1: 68.852,
    x2: 184.861,
    y2: 61.9043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_559_64061",
    x1: 131.357,
    y1: 68.852,
    x2: 184.861,
    y2: 61.9043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_559_64061",
    x1: 150.932,
    y1: 68.8424,
    x2: 183.205,
    y2: 65.1663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_559_64061",
    x1: 193.361,
    y1: 27.2168,
    x2: 197.946,
    y2: 23.9959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_559_64061",
    x1: 202.568,
    y1: 27.2168,
    x2: 207.04,
    y2: 20.4064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_559_64061",
    x1: 219.543,
    y1: 27.2168,
    x2: 223.835,
    y2: 24.6516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_559_64061",
    x1: 186.949,
    y1: 35.8088,
    x2: 190.459,
    y2: 27.5557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_559_64061",
    x1: 212.332,
    y1: 35.8088,
    x2: 217.081,
    y2: 29.846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_559_64061",
    x1: 188.621,
    y1: 44.4009,
    x2: 193.492,
    y2: 39.3976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_559_64061",
    x1: 200.648,
    y1: 44.4008,
    x2: 204.578,
    y2: 36.6463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_559_64061",
    x1: 221.164,
    y1: 44.4009,
    x2: 224.609,
    y2: 42.9742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_559_64061",
    x1: 186.949,
    y1: 52.9831,
    x2: 190.459,
    y2: 44.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_559_64061",
    x1: 211.496,
    y1: 52.9831,
    x2: 216.158,
    y2: 46.6921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_559_64061",
    x1: 193.361,
    y1: 61.5752,
    x2: 197.946,
    y2: 58.3543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_559_64061",
    x1: 202.568,
    y1: 61.5752,
    x2: 207.04,
    y2: 54.7648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_559_64061",
    x1: 219.543,
    y1: 61.5752,
    x2: 223.835,
    y2: 59.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_559_64061",
    x1: 186.949,
    y1: 70.1672,
    x2: 190.459,
    y2: 61.9141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_559_64061",
    x1: 212.332,
    y1: 70.1672,
    x2: 217.116,
    y2: 64.3696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_559_64061",
    x1: 130.857,
    y1: 77.9528,
    x2: 133.406,
    y2: 68.9267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_559_64061",
    x1: 169.477,
    y1: 77.9528,
    x2: 171.893,
    y2: 68.8484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_559_64061",
    x1: 211.439,
    y1: 77.9528,
    x2: 215.962,
    y2: 71.2663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_559_64061",
    x1: 130.857,
    y1: 86.5353,
    x2: 135.73,
    y2: 81.7277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_559_64061",
    x1: 145.842,
    y1: 86.5353,
    x2: 149.066,
    y2: 78.0089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_559_64061",
    x1: 174.125,
    y1: 86.5353,
    x2: 178.669,
    y2: 79.9021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_559_64061",
    x1: 193.602,
    y1: 86.5353,
    x2: 197.987,
    y2: 79.5386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_559_64061",
    x1: 213.484,
    y1: 86.5353,
    x2: 218.242,
    y2: 80.6089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_559_64061",
    x1: 273.889,
    y1: 93.6583,
    x2: 336.371,
    y2: 88.7289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_559_64061",
    x1: 311.539,
    y1: 34.0345,
    x2: 332.291,
    y2: 31.7649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_559_64061",
    x1: 286.848,
    y1: 82.2824,
    x2: 349.33,
    y2: 77.3541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_559_64061",
    x1: 324.48,
    y1: 22.676,
    x2: 345.16,
    y2: 20.4221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_559_64061",
    x1: 295.555,
    y1: 34.2536,
    x2: 300.423,
    y2: 29.5994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_559_64061",
    x1: 308.074,
    y1: 34.2537,
    x2: 311.891,
    y2: 26.351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_559_64061",
    x1: 331.143,
    y1: 34.2536,
    x2: 335.419,
    y2: 31.7161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_559_64061",
    x1: 293.951,
    y1: 41.5112,
    x2: 297.424,
    y2: 33.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_559_64061",
    x1: 321.34,
    y1: 41.5112,
    x2: 325.591,
    y2: 34.256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_559_64061",
    x1: 293.951,
    y1: 48.7688,
    x2: 298.757,
    y2: 44.6987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_559_64061",
    x1: 305.453,
    y1: 48.7688,
    x2: 308.644,
    y2: 40.2129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_559_64061",
    x1: 333.34,
    y1: 48.7688,
    x2: 336.331,
    y2: 47.7424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_559_64061",
    x1: 293.951,
    y1: 56.0264,
    x2: 297.424,
    y2: 47.7352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_559_64061",
    x1: 320.219,
    y1: 56.0264,
    x2: 324.314,
    y2: 48.5129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_559_64061",
    x1: 295.555,
    y1: 63.284,
    x2: 300.423,
    y2: 58.6298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_559_64061",
    x1: 308.074,
    y1: 63.2841,
    x2: 311.891,
    y2: 55.3814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_559_64061",
    x1: 331.143,
    y1: 63.284,
    x2: 335.419,
    y2: 60.7465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_559_64061",
    x1: 293.951,
    y1: 70.5416,
    x2: 297.424,
    y2: 62.2504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_559_64061",
    x1: 321.34,
    y1: 70.5513,
    x2: 325.662,
    y2: 63.4288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_559_64061",
    x1: 113.674,
    y1: 188.278,
    x2: 217.737,
    y2: 174.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_559_64061",
    x1: 117.332,
    y1: 184.811,
    x2: 213.377,
    y2: 171.671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_559_64061",
    x1: 117.313,
    y1: 184.811,
    x2: 170.142,
    y2: 177.311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_559_64061",
    x1: 152.535,
    y1: 184.811,
    x2: 210.493,
    y2: 177.856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_559_64061",
    x1: 126.719,
    y1: 134.535,
    x2: 146.777,
    y2: 127.399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_559_64061",
    x1: 141.297,
    y1: 335.962,
    x2: 145.793,
    y2: 334.661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_559_64061",
    x1: 141.293,
    y1: 335.762,
    x2: 144.204,
    y2: 335.493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_559_64061",
    x1: 84.3828,
    y1: 325.767,
    x2: 149.989,
    y2: 322.512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_559_64061",
    x1: 132.188,
    y1: 326.276,
    x2: 159.626,
    y2: 325.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_559_64061",
    x1: 130.715,
    y1: 326.468,
    x2: 145.788,
    y2: 321.246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_559_64061",
    x1: 82.6055,
    y1: 335.813,
    x2: 84.437,
    y2: 335.738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_559_64061",
    x1: 80.9648,
    y1: 335.811,
    x2: 84.3418,
    y2: 335.373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_559_64061",
    x1: 82.8672,
    y1: 326.775,
    x2: 99.0073,
    y2: 322.058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_559_64061",
    x1: 240.682,
    y1: 187.172,
    x2: 361.385,
    y2: 168.603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_559_64061",
    x1: 243.332,
    y1: 184.532,
    x2: 358.182,
    y2: 166.498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_559_64061",
    x1: 282.758,
    y1: 161.281,
    x2: 312.707,
    y2: 158.008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_559_64061",
    x1: 246.777,
    y1: 174.452,
    x2: 254.557,
    y2: 158.836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_559_64061",
    x1: 360.184,
    y1: 154.974,
    x2: 377.789,
    y2: 153.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_559_64061",
    x1: 330.088,
    y1: 191.166,
    x2: 372.408,
    y2: 187.918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_559_64061",
    x1: 324.238,
    y1: 159.438,
    x2: 340.616,
    y2: 158.078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_559_64061",
    x1: 322.926,
    y1: 241.968,
    x2: 378.112,
    y2: 229.932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_559_64061",
    x1: 416.604,
    y1: 241.838,
    x2: 418.547,
    y2: 241.736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_559_64061",
    x1: 414.604,
    y1: 241.272,
    x2: 417.226,
    y2: 241.049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_559_64061",
    x1: 348.91,
    y1: 336.268,
    x2: 353.461,
    y2: 334.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_559_64061",
    x1: 350.389,
    y1: 335.711,
    x2: 353.583,
    y2: 335.372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_559_64061",
    x1: 322.637,
    y1: 240.721,
    x2: 380.394,
    y2: 236.057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_559_64061"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(401.469 5.78157)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_559_64061"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(5.86523 22.5416)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCmsHeader);
export default __webpack_public_path__ + "static/media/CMS-Header.e6e535f560554c04d9c3485965270ae9.svg";
export { ForwardRef as ReactComponent };